/* ==========================================================================
   NGM PERFORMANCE CONFIGURATOR — Logik  (v4.13)
   --------------------------------------------------------------------------
   v4.13 (12.10.2026, FIN-Pflicht + Steuergeraet):
   - Fahrzeuge mit ecu = true (Metaobjekt ecu_replacement) zeigen #nc-ecu.
     Kauf erst mit gueltiger FIN (17 Zeichen, ohne I/O/Q) UND kaufbarem
     Steuergeraet-Produkt (NC_CFG.ecu_available), sonst fail-closed.
   - cart/add.js legt das Steuergeraet als eigene Position vor die Lizenz,
     FIN als Property "FIN / VIN" an beiden Positionen. Liegt dieselbe FIN
     schon als Steuergeraet im Warenkorb (zweite Lizenz), nur die Lizenz.
   - Gesamtpreis (Karte, CTA, Leiste) rechnet das Steuergeraet mit ein.
   --------------------------------------------------------------------------
   v4.12 (07.09.2026, Produktseiten-Audit):
   - ncFmt(): Preise folgen dem Shopify-Waehrungsformat (money_sample aus
     #v-shop-config, in der aktiven Markets-Waehrung gerendert) statt
     Intl.NumberFormat. Damit sehen Fahrzeugkarte, CTA und Sticky-Leiste
     genauso aus wie Warenkorb und Checkout. Fallback bleibt Intl.
   - Fahrzeug-Hinweis: fuehrendes "Hinweis:" / "Note:" aus den Metaobjekt-
     Notizen wird entfernt, das Label der Box heisst schon so.
   --------------------------------------------------------------------------
   Gehoert zu: sections/ngm-performance-configurator.liquid

   v4.11 (07.09.2026, UX-Struktur-Paket zur Section v4.14):
   - ncPriceSync(): Gesamtpreis inkl. Adapter, sobald "Nein, mitbestellen"
     gewaehlt ist (Fahrzeugleiste, Abschluss-CTA, Sticky-Leiste + Zusatzzeile
     "inkl. NGM Adapter (Preis)"). Preisquelle: adapter_price_cents aus
     #v-shop-config (Markets-umgerechnet). Der Finanzierungs-Observer auf
     #v-sel-price liest weiter die Lizenz-Variante, nicht den Text.
   - ncRevealSelection(): nach einer manuellen Fahrzeugwahl (Dropdown oder
     Chip) sanft zur Adapter-Frage bzw. Fahrzeugleiste scrollen, wenn sie
     nicht komplett im Bild ist. Nicht beim Prefill (autoPrefill scrollt selbst).
   - URL-Prefill auch teilweise: ?brand=Volkswagen&model=... setzt so weit
     wie vorhanden (vorher nur mit allen vier Parametern).
   - .nc-field.has-value fuer das Mini-Label ueber der Auswahl.
   - aria-pressed auf den Diagramm-Umschaltern, aria-label auf dem SVG.
   Ausgelagert aus dem frueheren Custom-Liquid-Block, weil der bei 50 KB
   endet und v44 mit 60 KB nicht mehr hineinpasste.

   Diese Datei enthaelt KEIN Liquid und darf keins enthalten — Shopify
   rendert Assets nicht durch die Template-Engine.
   Alles Shop-Abhaengige kommt aus drei JSON-Bloecken in der Section:
     #v-shop-config    Waehrungen (shop.currency / cart.currency.iso_code) + Adapter-Fakten (v4.8: adapter_variant_id, adapter_available, adapter_owner)
     #v-data-final     Fahrzeuge aus dem Metaobjekt vehicle_config
     #v-variants-data  Varianten des aktuellen Produkts

   Sprache: /de im Pfad = Deutsch (NC_T + ncApplyLang). Bewusst NICHT ueber
   request.locale — das liefert im Weglot-Setup immer 'en'.

   WICHTIG — Einbindung ohne defer:
   Das Script haengt einen submit-Listener in der CAPTURE-Phase an document,
   genau wie der Cart-Drawer, und der ruft dort stopImmediatePropagation().
   Capture-Listener feuern in Registrierungsreihenfolge. Mit defer liefe
   diese Datei erst nach dem Parsen und damit NACH dem Drawer — der wuerde
   das submit-Event schlucken, bevor syncProps() das Fahrzeug ins Formular
   schreibt. Ausserdem setzt ncApplyLang() die deutschen Labels synchron;
   mit defer koennte auf /de kurz "Brand" statt "Marke" aufblitzen.
   Deshalb: <script src="..."></script> an derselben Stelle wie frueher der
   Inline-Block. Die Datei wird vom Browser gecacht, das Blockieren kostet
   ab dem zweiten Seitenaufruf nichts mehr.
   ========================================================================== */

(function() {
 'use strict';
 var root = document.getElementById('ngm-v-restore-root');
 if (!root) return;
 /* ═══════════════════════════════════════════════════════════════════════
    SPRACHE (v4.4)
    ───────────────────────────────────────────────────────────────────────
    request.locale.iso_code liefert im Weglot-Setup IMMER 'en'. Die Labels
    dürfen deshalb nicht aus Liquid kommen — sonst rendert der Shop englisch
    und Weglot übersetzt im Frontend mit eigenen Formulierungen nach
    ("Jahr" statt "Baujahr", Siezen statt Duzen) und lässt Wörter wie
    "Brand" ganz stehen.
    Erkennung wie im Cart-Drawer v4.5: /de im Pfad = Deutsch.
    Alle Texte tragen data-wg-notranslate, Weglot fasst sie nicht mehr an.
    ═══════════════════════════════════════════════════════════════════════ */
 var _ngmIsDE = /^\/de(\/|$)/.test(window.location.pathname || '/');
 var NC_LANG = _ngmIsDE ? 'de' : 'en';

 var NC_T = {
  brand:            { de: 'Marke',            en: 'Brand' },
  model:            { de: 'Modell',           en: 'Model' },
  engine:           { de: 'Motor',            en: 'Engine' },
  year:             { de: 'Baujahr',          en: 'Year' },
  select:           { de: 'Fahrzeug wählen',  en: 'Select your vehicle' },
  addcart:          { de: 'In den Warenkorb', en: 'Add to Cart' },
  added:            { de: 'Hinzugefügt ✓',    en: 'Added ✓' },
  showall:          { de: 'Alle anzeigen',    en: 'Show all' },
  showless:         { de: 'Weniger anzeigen', en: 'Show less' },
  active:           { de: 'Aktiv',            en: 'Active' },
  activeprotocols:  { de: 'Aktive Protokolle', en: 'Active Protocols' },
  notice:           { de: 'Hinweis',          en: 'Notice' },
  cta_eyebrow:      { de: 'Bereit für dein Fahrzeug', en: 'Ready for your car' },
  stock:            { de: 'Serie',            en: 'Stock' },
  count:            { de: 'aktiv',            en: 'active' },
  pleaseselect:     { de: 'Bitte wähle zuerst dein Fahrzeug.', en: 'Please select your vehicle first.' },
  pricena:          { de: 'Preis n.v.',       en: 'Price N/A' },
  error:            { de: 'Fehler – erneut versuchen', en: 'Error – retry' },
  novariant:        { de: 'Keine passende Variante für', en: 'No matching variant for' },
  critical:         { de: 'Wichtiger Hinweis', en: 'Important Notice' },
  critical_btn:     { de: 'Mehr erfahren',    en: 'Learn more' },
  play:             { de: 'Video abspielen',  en: 'Play video' },
  chart_title:      { de: 'Leistungsdiagramm', en: 'Power chart' },
  both:             { de: 'Beide',            en: 'Both' },
  power:            { de: 'Leistung',         en: 'Power' },
  torque:           { de: 'Drehmoment',       en: 'Torque' },
  rpm_short:        { de: 'U/min',            en: 'rpm' },
  rpm_axis:         { de: 'U/MIN',            en: 'RPM' },
  disc_pre:         { de: 'Diese Leistungswerte werden ausschließlich unter optimalen Betriebsbedingungen und mit mindestens',
                      en: 'These performance figures are only achieved under optimal operating conditions and with a minimum of' },
  disc_octane:      { de: '102 ROZ',          en: '102 RON' },
  disc_post:        { de: 'Kraftstoff erreicht. Mit geringwertigerem Kraftstoff sind diese Werte nicht erreichbar.',
                      en: 'fuel. Lower-octane fuel will not deliver these results.' },
  /* v4.8: Adapter-Frage */
  adp_q:            { de: 'Hast du den NGM Bluetooth Adapter schon?', en: 'Do you already have the NGM Bluetooth Adapter?' },
  adp_eyebrow:      { de: 'Pflichtangabe · Adapter', en: 'Required · Adapter' },
  adp_sticky_q:     { de: 'Hast du den NGM Adapter schon?', en: 'Do you already have the NGM Adapter?' },
  adp_yes_short:    { de: 'Ja, habe ich', en: 'Yes, I have one' },
  adp_sub:          { de: 'Du brauchst ihn einmalig, um dein Fahrzeug mit der NGM App zu verbinden. Andere OBD-Adapter funktionieren nicht mit der NGM App.',
                      en: 'You need it once to connect your vehicle to the NGM App. Other OBD adapters do not work with the NGM App.' },
  adp_yes:          { de: 'Ja, habe ich schon', en: 'Yes, I have one' },
  adp_yes_sub:      { de: 'Nur die Lizenz, Original-NGM-Adapter erforderlich', en: 'License only, original NGM adapter required' },
  adp_no:           { de: 'Nein, mitbestellen', en: 'No, add it' },
  adp_no_soldout_title: { de: 'Nein, ich brauche einen', en: 'No, I need one' },
  adp_no_soldout:   { de: 'Derzeit ausverkauft, es wird nur die Lizenz hinzugefügt', en: 'Currently sold out, only the license will be added' },
  adp_first:        { de: 'Noch offen: Hast du den NGM Bluetooth Adapter schon?', en: 'Still open: Do you already have the NGM Bluetooth Adapter?' },
  adp_owner:        { de: 'Laut deinem Konto hast du schon einen NGM Adapter, deshalb ist Ja vorausgewählt. Du kannst das jederzeit ändern.', en: 'Your account shows you already own an NGM adapter, so Yes is preselected. You can change this anytime.' },
  /* v4.11 */
  incl_adapter:     { de: 'inkl. NGM Adapter', en: 'incl. NGM adapter' },
  /* v4.13: FIN-Pflicht + Steuergeraet */
  ecu_eyebrow:      { de: 'Pflichtangabe · FIN', en: 'Required · VIN' },
  ecu_q:            { de: 'Dieses Modell läuft nur mit einem neuen Steuergerät. Dafür brauchen wir deine FIN.', en: 'This model only works with a new ECU. We need your VIN for it.' },
  ecu_sub:          { de: 'Das Werks-Steuergerät lässt sich nicht über OBD beschreiben. Ohne das neue Steuergerät funktioniert die Lizenz bei diesem Modell nicht. Es wird auf deine Fahrgestellnummer (FIN) programmiert, automatisch mitbestellt und dir zugeschickt. Die FIN steht im Fahrzeugschein im Feld E.',
                      en: 'The factory ECU cannot be flashed through the OBD port. Without the new ECU the license does not work on this model. It is programmed to your vehicle identification number (VIN), added to your order automatically and shipped to you. You find the VIN in your registration document (field E in Germany).' },
  ecu_p_lic:        { de: 'Lizenz', en: 'License' },
  ecu_p_unit:       { de: 'Steuergerät (Pflicht, wird mitbestellt)', en: 'ECU (required, added automatically)' },
  ecu_p_total:      { de: 'Gesamtpreis', en: 'Total' },
  ecu_ship:         { de: 'Das Steuergerät wird an deine Lieferadresse verschickt.', en: 'The ECU is shipped to your delivery address.' },
  ecu_label:        { de: 'FIN (17 Zeichen)', en: 'VIN (17 characters)' },
  ecu_empty:        { de: 'Bitte die 17-stellige FIN eingeben.', en: 'Please enter the 17-character VIN.' },
  ecu_bad:          { de: 'Die FIN hat genau 17 Zeichen, die Buchstaben I, O und Q kommen nicht vor.', en: 'A VIN has exactly 17 characters and never contains I, O or Q.' },
  ecu_ok:           { de: 'FIN übernommen', en: 'VIN accepted' },
  ecu_unavail:      { de: 'Das Steuergerät ist gerade nicht bestellbar. Schreib uns kurz, wir melden uns.', en: 'The ECU cannot be ordered right now. Send us a short message and we will get back to you.' },
  ecu_legal:        { de: 'Das Steuergerät wird individuell auf deine FIN programmiert und passt in kein anderes Fahrzeug. Es ist deshalb vom Widerrufsrecht ausgeschlossen (§ 312g Abs. 2 Nr. 1 BGB).',
                      en: 'The ECU is programmed individually to your VIN and does not fit any other vehicle. It is therefore excluded from the right of withdrawal (Section 312g (2) No. 1 BGB).' },
  ecu_first:        { de: 'Noch offen: deine FIN', en: 'Still open: your VIN' },
  ecu_sticky:       { de: 'FIN eingeben, dann kaufen', en: 'Enter your VIN to continue' },
  incl_ecu:         { de: 'Steuergerät', en: 'ECU' },
  incl_adapter_short: { de: 'NGM Adapter', en: 'NGM adapter' },
  /* v4.13: Vormerken */
  soon_eyebrow:     { de: 'Bald verfügbar', en: 'Coming soon' },
  soon_q:           { de: 'Dieses Modell kommt in Kürze in die NGM App.', en: 'This model is coming to the NGM App soon.' },
  soon_sub:         { de: 'Preis und Ablauf stehen schon fest, bestellen kannst du noch nicht. Trag deine E-Mail ein, wir melden uns, sobald es losgeht.', en: 'Price and process are fixed, ordering is not open yet. Leave your e-mail and we will let you know as soon as it starts.' },
  soon_ok:          { de: 'Danke, du stehst auf der Liste. Wir melden uns, sobald du bestellen kannst.', en: 'Thanks, you are on the list. We will let you know as soon as you can order.' },
  soon_label:       { de: 'Deine E-Mail', en: 'Your e-mail' },
  soon_btn:         { de: 'Benachrichtige mich', en: 'Notify me' },
  soon_note:        { de: 'Nur für diese Benachrichtigung, kein Newsletter.', en: 'Used for this notification only, no newsletter.' },
  soon_atc:         { de: 'Bald verfügbar', en: 'Coming soon' },
  incl:             { de: 'inkl.', en: 'incl.' }
 };

 /* Ein Text in aktueller Sprache */
 function T(key) {
  var e = NC_T[key];
  return (e && (e[NC_LANG] || e.en)) || '';
 }

 /* L bleibt als Kurzform erhalten, wird aber aus NC_T gebaut statt aus Liquid */
 var L = {};
 for (var _k in NC_T) { L[_k] = T(_k); }

 /* Statische Markup-Texte setzen. Läuft synchron direkt nach dem Markup,
    also vor dem ersten Paint -> kein sichtbares Umspringen.

    Zwei Quellen:
    a) data-ngm-l10n="key"  -> fester Text aus NC_T (Labels der Bedienelemente)
    b) data-ngm-de / data-ngm-en -> frei eingetippter Text aus den Section-
       Einstellungen (Überschrift, Untertitel). Muss über Attribute laufen,
       weil request.locale im Weglot-Setup immer 'en' liefert und Liquid die
       Sprache damit nicht kennt. Ist ein Feld leer, gewinnt das gefüllte —
       so muss niemand beide Sprachen pflegen. */
 function ncApplyLang() {
  /* v4.7.1: Die Sticky-Leiste liegt seit dem Umzug aus .nc-band ausserhalb
     von root und wuerde von einer reinen root-Suche nicht mehr erfasst.
     Ihre Beschriftung setzt zwar auch ncEachAtc() bei jeder Fahrzeugwahl —
     aber sich darauf zu verlassen waere unnoetig zerbrechlich. */
  var l10nScopes = [root];
  var stickyBar = document.getElementById('v-sticky');
  if (stickyBar && !root.contains(stickyBar)) l10nScopes.push(stickyBar);
  l10nScopes.forEach(function(scope) {
   scope.querySelectorAll('[data-ngm-l10n]').forEach(function(el) {
    var t = T(el.getAttribute('data-ngm-l10n'));
    if (t && el.textContent !== t) el.textContent = t;
   });
  });
  l10nScopes.forEach(function(scope) { scope.querySelectorAll('[data-ngm-de],[data-ngm-en]').forEach(function(el) { /* v4.10: auch in der Sticky-Leiste (#nc-adp-sticky) */
   var de = el.getAttribute('data-ngm-de') || '';
   var en = el.getAttribute('data-ngm-en') || '';
   var t  = NC_LANG === 'de' ? (de || en) : (en || de);
   if (el.textContent !== t) el.textContent = t;
   /* Beide Felder leer -> Zeile ausblenden statt leeren Platz zu lassen */
   el.hidden = !t;
  }); });
 }
 ncApplyLang();

 /* ═══════════════════════════════════════════════════════════════════════
    WÄHRUNG
    ───────────────────────────────────────────────────────────────────────
    NC_BASE_CUR   = Shop-Hauptwährung. In dieser Währung stehen die
                    Metaobjekt-Cents (currentV.p).
    NC_ACTIVE_CUR = Währung, die der Besucher gerade sieht.
    NC_FX         = Kurs Shop-Währung -> aktive Währung, den das Theme
                    selbst ins Frontend schreibt.
    NC_IS_BASE    = true, solange keine Umrechnung stattfindet.

    Wichtig: variant.price kommt aus Liquid und ist von Shopify Markets
    BEREITS umgerechnet — currentV.p dagegen nicht. Die beiden dürfen
    deshalb nur verglichen werden, wenn NC_IS_BASE gilt.
    ═══════════════════════════════════════════════════════════════════════ */
 /* v4.5: kommt jetzt aus <script id="v-shop-config"> in der Section,
    damit diese Datei reines JavaScript ohne Liquid bleibt. */
 var NC_CFG = {};
 try { NC_CFG = JSON.parse(document.getElementById('v-shop-config').textContent || '{}'); }
 catch (e) { console.error('[NGM Config] shop-config parse failed:', e); }
 var NC_BASE_CUR   = NC_CFG.base_currency || 'EUR';
 var NC_ACTIVE_CUR = NC_CFG.active_currency || NC_BASE_CUR;
 var NC_IS_BASE    = (NC_ACTIVE_CUR === NC_BASE_CUR);
 var NC_FX = parseFloat((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || '1');
 if (!isFinite(NC_FX) || NC_FX <= 0) NC_FX = 1;
 var NC_LOCALE = _ngmIsDE ? 'de-DE' : 'en-US';

 /* v4.12: Waehrungsformat aus dem Liquid-Muster ableiten. money_sample ist
    1.234.567,89 in der aktiven Waehrung, z. B. "€1.234.567,89" oder
    "CHF 1'234'567.89". Daraus: Praefix, Suffix, Tausender-/Dezimaltrenner. */
 function ncParseMoneyFormat(sample) {
  var m = /^(.*?)(\d[\d.,'\u2019 \u00a0]*\d)(.*)$/.exec(String(sample || ''));
  if (!m) return null;
  var pre = m[1], num = m[2], suf = m[3];
  var digits = num.replace(/\D/g, '');
  var decimals = 0, dec = '';
  if (digits.length === 9 && digits.slice(-2) === '89') { decimals = 2; dec = num.charAt(num.length - 3); }
  else if (digits.length !== 7) return null;
  var body = decimals ? num.slice(0, -3) : num;
  var grp = body.replace(/\d/g, '').charAt(0) || '';
  return { pre: pre, suf: suf, grp: grp, dec: dec, decimals: decimals };
 }
 var NC_MONEY_FMT = ncParseMoneyFormat(NC_CFG.money_sample);

 /* Cents in AKTIVER Währung -> im Shop-Format, z. B. "€699,00" */
 function ncFmt(cents) {
  var amount = (Number(cents) || 0) / 100;
  var f = NC_MONEY_FMT;
  if (f) {
   var parts = Math.abs(amount).toFixed(f.decimals).split('.');
   var intp = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, f.grp);
   return (amount < 0 ? '-' : '') + f.pre + intp + (f.decimals ? f.dec + parts[1] : '') + f.suf;
  }
  try {
   return new Intl.NumberFormat(NC_LOCALE, { style: 'currency', currency: NC_ACTIVE_CUR }).format(amount);
  } catch (e) {
   return amount.toFixed(2) + ' ' + NC_ACTIVE_CUR;
  }
 }
 /* Cents in SHOP-Währung -> umgerechnet und formatiert (nur als Näherung,
    wenn keine Variante gefunden wurde) */
 function ncFmtConverted(cents) {
  return ncFmt(Math.round((Number(cents) || 0) * NC_FX));
 }

 /* v4.4: der frühere _ngmIsDE-Block, der v-critical-label, v-critical-btn-label,
    L.critical_btn und L.play einzeln nachgezogen hat, ist entfallen —
    ncApplyLang() und L aus NC_T decken das jetzt vollständig ab. */
 var CRITICAL_DEFAULTS = _ngmIsDE ? {
  "cupra|formentor vz5": "Der Cupra Formentor VZ5 erfordert einen Unlock der Motorsteuerung (ECU), bevor das Tuning durchgeführt werden kann. Die ECU muss dafür zur Firma Autotuner geschickt werden, um entsperrt zu werden. Ohne diesen Unlock ist ein NGM App Tuning leider nicht möglich. Weitere Informationen zum Unlock findest du hier: https://www.autotuner.com/de/products/unlock-vag-mg1cs163",
  "audi|rs3 8y": "Der Audi RS3 8Y erfordert einen Unlock der Motorsteuerung (ECU), bevor das Tuning durchgeführt werden kann. Die ECU muss dafür zur Firma Autotuner geschickt werden, um entsperrt zu werden. Ohne diesen Unlock ist ein NGM App Tuning leider nicht möglich. Weitere Informationen zum Unlock findest du hier: https://www.autotuner.com/de/products/unlock-vag-mg1cs163"
 } : {
  "cupra|formentor vz5": "The Cupra Formentor VZ5 requires an unlock of the engine control unit (ECU) before tuning can be performed. The ECU must be sent to the company Autotuner to be unlocked. Without this unlock, NGM app tuning is unfortunately not possible. More information about the unlock can be found here: https://www.autotuner.com/de/products/unlock-vag-mg1cs163",
  "audi|rs3 8y": "The Audi RS3 8Y requires an unlock of the engine control unit (ECU) before tuning can be performed. The ECU must be sent to the company Autotuner to be unlocked. Without this unlock, NGM app tuning is unfortunately not possible. More information about the unlock can be found here: https://www.autotuner.com/de/products/unlock-vag-mg1cs163"
 };
 /* v4.13: Metaobjekt-Feld special_restrictions (uebersetzt via Translate & Adapt)
    hat Vorrang vor der festen Liste. Enthaelt es eine URL, wird sie zum Button. */
 function getCritical(brand, model, spec) {
  if (spec && String(spec).trim()) return String(spec).trim();
  if (!brand || !model) return "";
  var b = String(brand).toLowerCase().trim(), m = String(model).toLowerCase().trim();
  for (var k in CRITICAL_DEFAULTS) { var p = k.split("|"); if (b.indexOf(p[0]) !== -1 && m.indexOf(p[1]) !== -1) return CRITICAL_DEFAULTS[k]; }
  return "";
 }
 window.__NGM_CONFIGURATOR = { active: false, variantId: null, vehicle: '', lic: '', adapter: null };
 var data = [];
 try { data = JSON.parse(document.getElementById('v-data-final').textContent || "[]"); } catch(e) { console.error("Data error", e); }
 var allVariants = [];
 try { allVariants = JSON.parse(document.getElementById('v-variants-data').textContent || "[]"); } catch(e) { console.error("Variants error", e); }
 var bS = document.getElementById('f-brand'), mS = document.getElementById('f-model'), eS = document.getElementById('f-engine'), yS = document.getElementById('f-year'), atcBtn = document.getElementById('nc-atc-btn');
 /* v4.6: Es gibt jetzt ZWEI Kaufbuttons — den in der Fahrzeugleiste oben und
    den grossen Abschluss-CTA unten. Beide muessen immer denselben Zustand
    tragen (Variante, Beschriftung, disabled), sonst kauft der eine, waehrend
    der andere noch "Preis n.v." zeigt. atcBtn bleibt der Primaere: an ihm
    haengen syncGlobalState() und das Highlight aus autoPrefill().
    querySelectorAll findet beide, weil sie im Section-Markup stehen und
    dieses Script ohne defer laeuft — das DOM davor ist bereits geparst. */
 var atcBtns = Array.prototype.slice.call(document.querySelectorAll('.nc-atc-btn'));
 function ncEachAtc(fn) { atcBtns.forEach(fn); }

 /* ═══════════════════════════════════════════════════════════════════════
    STICKY-KAUFLEISTE (v4.7.1) — nur Handy
    ───────────────────────────────────────────────────────────────────────
    Sichtbar, sobald ein Fahrzeug gewaehlt ist UND die obere Fahrzeugleiste
    nicht mehr im Bild steht. Sonst zeigen beide gleichzeitig denselben
    Preis und denselben Kaufbutton — das sah aus wie ein Fehler.

    Gemessen wird bei jedem Scroll frisch ueber getBoundingClientRect(),
    gedrosselt mit requestAnimationFrame (hoechstens einmal pro Bildaufbau).
    Bewusst KEIN IntersectionObserver: der meldet nur Zustandswechsel. Beim
    Scrollen durch einen langen Bereich, in dem sich am Sichtbarkeitsstatus
    nichts aendert, kaeme kein Callback — die Leiste bliebe haengen.

    Die Klasse am <body> gleicht die Hoehe der Leiste aus, damit sie die
    letzten ~70px der Seite nicht verdeckt. Sie sitzt am <body>, weil der
    Seitenfuss ausserhalb des Konfigurators liegt; die Regel dazu greift
    nur unter 749px.
    ═══════════════════════════════════════════════════════════════════════ */
 var ncStickyApply = function () {};
 (function ncStickyInit() {
  var bar = document.getElementById('v-sticky');
  if (!bar) return;
  var info = document.getElementById('v-info-bar');

  ncStickyApply = function () {
   var on = false;
   if (currentV) {
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    var ir = info ? info.getBoundingClientRect() : null;
    /* Ausgeblendete Elemente liefern lauter Nullen — height mitpruefen,
       sonst gilt die versteckte Leiste faelschlich als "im Bild". */
    var infoVisible = !!(ir && ir.height && ir.bottom > 0 && ir.top < vh);
    on = !infoVisible;
   }
   bar.classList.toggle('nc-hide', !on);
   bar.setAttribute('aria-hidden', on ? 'false' : 'true');
   if (document.body) document.body.classList.toggle('nc-has-sticky', on);
   if (typeof ncLiftOverlays === 'function') ncLiftOverlays(); /* v4.11: Chat-Blase + Cookie-Symbol mitnehmen */
  };

  var ticking = false;
  function onScroll() {
   if (ticking) return;
   ticking = true;
   requestAnimationFrame(function () { ticking = false; ncStickyApply(); });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
 })();
 var currentV = null, activeMode = "both";
 /* v4.4: defaultVariantId entfernt — war deklariert, wurde nie gelesen.
    Die Varianten-ID kommt ausschließlich aus findVariantByPrice(). */

 /* ===== NGM Dyno-Chart Renderer v3.1 (realistic, responsive, mobile-stable) ===== */
 var NC_STATE=null, NC_AMP=0.009, NC_RZ=null, NC_BP=null;
 var NC_PSHAPE=[[0,.10],[.08,.17],[.16,.27],[.26,.40],[.37,.55],[.48,.69],[.58,.81],[.68,.90],[.78,.97],[.86,1],[.93,.985],[1,.91]];
 var NC_TSHAPE=[[0,.42],[.07,.60],[.13,.80],[.20,.95],[.27,1],[.40,1],[.50,.99],[.60,.95],[.70,.89],[.80,.80],[.90,.68],[1,.56]];
 function ncRip(t,s){return Math.sin(t*58+s*1.7)*0.5+Math.sin(t*142+s*0.6+1.1)*0.32+Math.sin(t*300+s*2.3)*0.16;}
 function ncEl(t,a){var e=document.createElementNS('http://www.w3.org/2000/svg',t);for(var k in a)e.setAttribute(k,a[k]);return e;}
 function ncHexA(h,a){var n=parseInt(h.slice(1),16);return'rgba('+(n>>16&255)+','+(n>>8&255)+','+(n&255)+','+a+')';}
 function ncFrac(sh,t){for(var i=0;i<sh.length-1;i++){if(t>=sh[i][0]&&t<=sh[i+1][0]){var a=sh[i],b=sh[i+1];return a[1]+(b[1]-a[1])*(t-a[0])/(b[0]-a[0]);}}return sh[sh.length-1][1];}
 function ncSmooth(p){if(p.length<2)return'';var d='M'+p[0][0].toFixed(1)+','+p[0][1].toFixed(1);for(var i=0;i<p.length-1;i++){var a=p[i-1]||p[i],b=p[i],c=p[i+1],e=p[i+2]||c,c1x=b[0]+(c[0]-a[0])/6,c1y=b[1]+(c[1]-a[1])/6,c2x=c[0]-(e[0]-b[0])/6,c2y=c[1]-(e[1]-b[1])/6;d+=' C'+c1x.toFixed(1)+','+c1y.toFixed(1)+' '+c2x.toFixed(1)+','+c2y.toFixed(1)+' '+c[0].toFixed(1)+','+c[1].toFixed(1);}return d;}
 function ncIsMobile(){var sv=document.getElementById('nc-cv-svg');var w=(sv&&sv.parentNode)?sv.parentNode.clientWidth:700;return w<560;}
 function ncGeo(){if(ncIsMobile())return{W:432,H:362,x0:46,x1:386,yT:34,yB:300,xt:[0,2,4,6],fs:8.5,cap:9};return{W:920,H:380,x0:66,x1:854,yT:40,yB:304,xt:[0,1,2,3,4,5,6],fs:10,cap:10};}
 function ncSeries(v){return [{l:T('stock'),c:'#aeb4be',pg:'#8b93a0',bar:'#8b93a0',dim:true,seed:4,ps:Math.max(v.s_ps,v.s_ps_to),nm:Math.max(v.s_nm,v.s_nm_to)},{l:'Stage 1',c:'#3da0ff',pg:'url(#nc-gB)',bar:'#3da0ff',seed:9,ps:v.s1_ps,nm:v.s1_nm},{l:'Stage 2',c:'#34f06a',pg:'url(#nc-gG)',bar:'#34f06a',hl:true,seed:14,ps:v.s2_ps,nm:v.s2_nm}];}
 function clearChart(){['nc-cv-grid','nc-cv-axis','grp-power','grp-torque','nc-cv-peaks','nc-cv-hover'].forEach(function(id){var e=document.getElementById(id);if(e)e.innerHTML='';});['nc-legend','nc-stats-row'].forEach(function(id){var e=document.getElementById(id);if(e){e.innerHTML='';e.classList.add('nc-hide');}});var c=document.getElementById('nc-cv-clip-rect');if(c)c.setAttribute('width',0);NC_STATE=null;}
 function ncReveal(animate){var c=document.getElementById('nc-cv-clip-rect'),pk=document.getElementById('nc-cv-peaks');if(!c||!NC_STATE)return;var W=NC_STATE.pW;if(!animate||!window.requestAnimationFrame){c.setAttribute('width',W);if(pk)pk.style.opacity=1;return;}if(pk)pk.style.opacity=0;var st=null;c.setAttribute('width',0);function f(ts){if(st===null)st=ts;var k=Math.min(1,(ts-st)/850);c.setAttribute('width',(W*(1-Math.pow(1-k,3))).toFixed(1));if(k<1){requestAnimationFrame(f);}else{c.setAttribute('width',W);if(pk)pk.style.opacity=1;}}requestAnimationFrame(f);}
 function ncBuildLegend(){var lg=document.getElementById('nc-legend');if(!lg)return;lg.classList.remove('nc-hide');lg.innerHTML='';[[T('stock'),'#8b93a0'],['Stage 1','#3da0ff'],['Stage 2','#34f06a']].forEach(function(s){var c=document.createElement('span');c.className='chip';c.innerHTML='<span class="dot" style="background:'+s[1]+'"></span>'+s[0];lg.appendChild(c);});var sp=document.createElement('span');sp.className='sep';lg.appendChild(sp);var l1=document.createElement('span');l1.className='chip';l1.innerHTML='<svg width="20" height="6"><line x1="0" y1="3" x2="20" y2="3" stroke="rgba(255,255,255,.6)" stroke-width="2.4"/></svg>'+T('power');lg.appendChild(l1);var l2=document.createElement('span');l2.className='chip';l2.innerHTML='<svg width="20" height="6"><line x1="0" y1="3" x2="20" y2="3" stroke="rgba(255,255,255,.6)" stroke-width="2" stroke-dasharray="4,3"/></svg>'+T('torque');lg.appendChild(l2);}
 function ncBuildRows(v){var box=document.getElementById('nc-stats-row');if(!box)return;box.classList.remove('nc-hide');box.innerHTML='';var sp=Math.max(v.s_ps,v.s_ps_to),sn=Math.max(v.s_nm,v.s_nm_to);[{l:T('stock'),ps:sp,nm:sn,c:'#aeb4be',bar:'#8b93a0',dim:1},{l:'Stage 1',ps:v.s1_ps,nm:v.s1_nm,c:'#3da0ff',bar:'#3da0ff'},{l:'Stage 2',ps:v.s2_ps,nm:v.s2_nm,c:'#34f06a',bar:'#34f06a',hl:1}].forEach(function(r,i){var chips='';if(i>0&&r.ps>0){chips='<div class="nc-chips"><span class="nc-chip2" style="background:'+ncHexA(r.bar,.16)+';color:'+r.c+'">+'+(r.ps-sp)+' PS</span><span class="nc-chip2" style="background:'+ncHexA(r.bar,.16)+';color:'+r.c+'">+'+(r.nm-sn)+' Nm</span></div>';}var bsh=r.dim?'':';box-shadow:0 0 10px '+ncHexA(r.bar,.55);var d=document.createElement('div');d.className='nc-row'+(r.hl?' hl':'');d.innerHTML='<span class="nc-bar" style="background:'+r.bar+bsh+'"></span><div class="nc-meta"><div class="nc-rl"'+(r.hl?' style="color:rgba(52,240,106,.7)"':'')+'>'+r.l+'</div><div class="nc-rnm">'+(r.nm>0?r.nm+' Nm':'')+'</div></div><div class="nc-right"><div class="nc-rps" style="color:'+r.c+(r.hl?';text-shadow:0 0 18px rgba(52,240,106,.35)':'')+'">'+(r.ps>0?r.ps:'—')+'<i>PS</i></div>'+chips+'</div>';box.appendChild(d);});}
 function ncHoverAt(t){var S=NC_STATE,hov=document.getElementById('nc-cv-hover');if(!S||!hov)return;hov.innerHTML='';var X=S.px(t);hov.appendChild(ncEl('line',{x1:X,y1:S.yT,x2:X,y2:S.yB,stroke:'rgba(255,255,255,.25)','stroke-width':1,'stroke-dasharray':'3,3'}));var rows=S.SR.filter(function(s){return s.ps>0||s.nm>0;}).map(function(s){var pvc=s.ps*ncFrac(NC_PSHAPE,t),tvc=s.nm*ncFrac(NC_TSHAPE,t);if(S.mode!=='torque'&&s.ps>0)hov.appendChild(ncEl('circle',{cx:X,cy:S.pyP(pvc+s.ps*NC_AMP*ncRip(t,s.seed)),r:3.5,fill:s.c,stroke:'#0a0e15','stroke-width':1.5}));if(S.mode!=='power'&&s.nm>0)hov.appendChild(ncEl('circle',{cx:X,cy:S.pyT(tvc+s.nm*NC_AMP*ncRip(t,s.seed+1)),r:3.5,fill:s.c,stroke:'#0a0e15','stroke-width':1.5,'fill-opacity':.85}));return{l:s.l,c:s.c,pv:Math.round(pvc),tv:Math.round(tvc),ps:s.ps};});if(!rows.length)return;var rpm=Math.round((1000+t*6000)/50)*50,bw=S.mode==='both'?206:150,rh=19,bh=30+rows.length*rh+8,left=X>S.x0+S.pW*.55,bx=left?X-bw-14:X+14,last=rows[rows.length-1],ay=last.ps>0?S.pyP(last.pv):S.pyT(last.tv),by=Math.max(S.yT,Math.min(S.yB-bh,ay-bh/2)),g=ncEl('g',{});g.appendChild(ncEl('rect',{x:bx,y:by,width:bw,height:bh,rx:9,fill:'rgba(8,11,16,.96)',stroke:'rgba(52,240,106,.25)','stroke-width':1}));var hd=ncEl('text',{x:bx+13,y:by+19,fill:'rgba(255,255,255,.5)','font-size':10,'font-family':"'DM Mono',monospace"});hd.textContent=rpm.toLocaleString(NC_LOCALE)+' '+T('rpm_short');g.appendChild(hd);rows.forEach(function(r,i){var ry=by+30+i*rh+12;g.appendChild(ncEl('circle',{cx:bx+15,cy:ry-3.5,r:4,fill:r.c}));var lab=ncEl('text',{x:bx+27,y:ry,fill:'rgba(255,255,255,.85)','font-size':11,'font-family':"'DM Mono',monospace"});lab.textContent=r.l+'  '+(S.mode==='power'?r.pv+' PS':S.mode==='torque'?r.tv+' Nm':r.pv+' PS · '+r.tv+' Nm');g.appendChild(lab);});hov.appendChild(g);hov.style.opacity=1;}
 function ncBindHover(){var hit=document.getElementById('nc-cv-hit'),svg=document.getElementById('nc-cv-svg');if(!hit||hit._ncBound)return;hit._ncBound=true;function at(cx){var r=svg.getBoundingClientRect();var t=Math.max(0,Math.min(1,((cx-r.left)*NC_STATE.geo.W/r.width-NC_STATE.x0)/NC_STATE.pW));ncHoverAt(t);}hit.addEventListener('mousemove',function(e){if(NC_STATE)at(e.clientX);});hit.addEventListener('mouseleave',function(){var h=document.getElementById('nc-cv-hover');if(h)h.style.opacity=0;});hit.addEventListener('touchmove',function(e){if(NC_STATE&&e.touches[0])at(e.touches[0].clientX);},{passive:true});hit.addEventListener('touchend',function(){var h=document.getElementById('nc-cv-hover');if(h)h.style.opacity=0;});}
 function renderChart(v,mode,animate){var svg=document.getElementById('nc-cv-svg');if(!svg)return;var G=ncGeo(),x0=G.x0,x1=G.x1,yT=G.yT,yB=G.yB,pW=x1-x0,pH=yB-yT;svg.setAttribute('viewBox','0 0 '+G.W+' '+G.H);var clr=document.getElementById('nc-cv-clip-rect');if(clr){clr.setAttribute('x',x0);clr.setAttribute('y',yT);clr.setAttribute('height',pH);}var hit=document.getElementById('nc-cv-hit');if(hit){hit.setAttribute('x',x0);hit.setAttribute('y',yT);hit.setAttribute('width',pW);hit.setAttribute('height',pH);}var SR=ncSeries(v);function ax6(p,r){var s=Math.ceil((p*1.06/6)/r)*r||r;return{s:s,max:s*6};}var PA=ax6(Math.max(SR[0].ps,SR[1].ps,SR[2].ps,1),25),TA=ax6(Math.max(SR[0].nm,SR[1].nm,SR[2].nm,1),100);var px=function(t){return x0+t*pW;},pyP=function(val){return yB-(val/PA.max)*pH;},pyT=function(val){return yB-(val/TA.max)*pH;};function curve(peak,shape,py,seed){var a=[];for(var n=0;n<46;n++){var t=n/45;a.push([px(t),py(peak*ncFrac(shape,t)+peak*NC_AMP*ncRip(t,seed))]);}return a;}var grid=document.getElementById('nc-cv-grid'),axis=document.getElementById('nc-cv-axis'),gP=document.getElementById('grp-power'),gT=document.getElementById('grp-torque'),peaks=document.getElementById('nc-cv-peaks'),hov=document.getElementById('nc-cv-hover');grid.innerHTML='';axis.innerHTML='';gP.innerHTML='';gT.innerHTML='';peaks.innerHTML='';if(hov)hov.innerHTML='';for(var i=0;i<=6;i++){var y=yB-(i/6)*pH;grid.appendChild(ncEl('line',{x1:x0,y1:y,x2:x1,y2:y,stroke:i===0?'rgba(255,255,255,.13)':'rgba(255,255,255,.045)','stroke-width':1}));var lt=ncEl('text',{x:x0-9,y:y+3,fill:'rgba(255,255,255,.3)','font-size':G.fs,'text-anchor':'end','font-family':"'DM Mono',monospace"});lt.textContent=Math.round(PA.max*i/6);lt.setAttribute('class','ax-p');axis.appendChild(lt);var rt=ncEl('text',{x:x1+9,y:y+3,fill:'rgba(255,255,255,.3)','font-size':G.fs,'text-anchor':'start','font-family':"'DM Mono',monospace"});rt.textContent=Math.round(TA.max*i/6/50)*50;rt.setAttribute('class','ax-t');axis.appendChild(rt);}axis.appendChild(ncEl('line',{x1:x0,y1:yT,x2:x0,y2:yB,stroke:'rgba(255,255,255,.13)','stroke-width':1}));axis.appendChild(ncEl('line',{x1:x1,y1:yT,x2:x1,y2:yB,stroke:'rgba(255,255,255,.13)','stroke-width':1}));var capL=ncEl('text',{x:x0,y:yT-12,fill:'rgba(255,255,255,.45)','font-size':G.cap,'text-anchor':'middle','font-family':"'DM Mono',monospace"});capL.textContent='PS';capL.setAttribute('class','ax-p');axis.appendChild(capL);var capR=ncEl('text',{x:x1,y:yT-12,fill:'rgba(255,255,255,.45)','font-size':G.cap,'text-anchor':'middle','font-family':"'DM Mono',monospace"});capR.textContent='Nm';capR.setAttribute('class','ax-t');axis.appendChild(capR);G.xt.forEach(function(j){var xx=px(j/6);if(j>0&&j<6)grid.appendChild(ncEl('line',{x1:xx,y1:yT,x2:xx,y2:yB,stroke:'rgba(255,255,255,.025)','stroke-width':1}));var xt=ncEl('text',{x:xx,y:yB+20,fill:'rgba(255,255,255,.3)','font-size':G.fs,'text-anchor':'middle','font-family':"'DM Mono',monospace"});xt.textContent=(1000+j*1000).toLocaleString(NC_LOCALE);axis.appendChild(xt);});var capX=ncEl('text',{x:(x0+x1)/2,y:yB+(G.W<500?36:40),fill:'rgba(255,255,255,.24)','font-size':G.fs,'text-anchor':'middle','font-family':"'DM Mono',monospace",'letter-spacing':'.14em'});capX.textContent=T('rpm_axis');axis.appendChild(capX);var topI=(SR[2].ps>=SR[1].ps)?2:1;if(SR[topI].ps>0){var ar=[];for(var m=0;m<46;m++){var tt=m/45;ar.push([px(tt),pyP(SR[topI].ps*ncFrac(NC_PSHAPE,tt))]);}gP.appendChild(ncEl('path',{d:ncSmooth(ar)+' L'+x1+','+yB+' L'+x0+','+yB+' Z',fill:'url(#nc-gArea)',stroke:'none'}));}SR.forEach(function(s){if(s.nm>0){var tl=ncEl('path',{d:ncSmooth(curve(s.nm,NC_TSHAPE,pyT,s.seed+1)),fill:'none',stroke:s.pg,'stroke-width':2,'stroke-dasharray':'7,5','stroke-linecap':'round'});tl.style.opacity=s.dim?.5:.85;gT.appendChild(tl);}});SR.forEach(function(s){if(s.ps>0){var pl=ncEl('path',{d:ncSmooth(curve(s.ps,NC_PSHAPE,pyP,s.seed)),fill:'none',stroke:s.pg,'stroke-width':s.dim?2:3,'stroke-linecap':'round','stroke-linejoin':'round'});if(s.dim)pl.style.opacity=.6;else pl.setAttribute('filter','url(#nc-gl)');gP.appendChild(pl);}});var pkPow=ncEl('g',{}),pkTor=ncEl('g',{});peaks.appendChild(pkTor);peaks.appendChild(pkPow);pkPow.style.transition=pkTor.style.transition='opacity .3s';function pill(grp,x,y,txt,col){var w=txt.length*6.6+16,bx=Math.max(x0,Math.min(x1-w,x-w/2)),by=y-26;grp.appendChild(ncEl('circle',{cx:x,cy:y,r:4.5,fill:col,stroke:'#0a0e15','stroke-width':2,filter:'url(#nc-gl)'}));grp.appendChild(ncEl('rect',{x:bx,y:by,width:w,height:18,rx:9,fill:'rgba(8,11,16,.92)',stroke:col,'stroke-opacity':.5,'stroke-width':1}));var t=ncEl('text',{x:bx+w/2,y:by+12.5,fill:col,'font-size':10,'font-weight':600,'text-anchor':'middle','font-family':"'DM Mono',monospace"});t.textContent=txt;grp.appendChild(t);}if(SR[2].ps>0)pill(pkPow,px(.86),pyP(SR[2].ps),SR[2].ps+' PS','#5dffa0');if(SR[2].nm>0)pill(pkTor,px(.33),pyT(SR[2].nm),SR[2].nm+' Nm','#5dffa0');gP.style.opacity=mode==='torque'?0:1;gT.style.opacity=mode==='power'?0:1;pkPow.style.opacity=mode==='torque'?0:1;pkTor.style.opacity=mode==='power'?0:1;axis.querySelectorAll('.ax-p').forEach(function(e){e.style.opacity=mode==='torque'?.25:1;});axis.querySelectorAll('.ax-t').forEach(function(e){e.style.opacity=mode==='power'?.25:1;});NC_STATE={SR:SR,mode:mode,px:px,pyP:pyP,pyT:pyT,x0:x0,yT:yT,yB:yB,pW:pW,geo:G};NC_BP=ncIsMobile();ncBindHover();ncReveal(animate);}

 /* ═══════════════════════════════════════════════════════════════════════
    VARIANTEN-MATCHING (währungssicher)
    ───────────────────────────────────────────────────────────────────────
    priceCents kommt aus dem Metaobjekt und ist IMMER in Shop-Währung.
    variant.price ist dagegen in der Währung des Besuchers.

    -> Der direkte Cent-Vergleich ist nur in der Shop-Währung gültig.
       In Fremdwährung matcht ausschließlich der Varianten-Titel; der ist
       ein statischer Text (z.B. "699") und ändert sich nie mit.
    Gibt das Varianten-Objekt zurück (nicht nur die ID), damit der Aufrufer
    den echten, von Shopify umgerechneten Preis anzeigen kann.
    ═══════════════════════════════════════════════════════════════════════ */
 function findVariantByPrice(priceCents) {
  var match;
  if (NC_IS_BASE) {
   match = allVariants.find(function(v) { return v.price === priceCents; });
   if (match) return match;
  }
  var priceEur = Math.round(priceCents / 100);
  match = allVariants.find(function(v) { return parseInt(v.title, 10) === priceEur; });
  if (match) return match;
  var priceStr = (priceCents / 100).toFixed(2);
  var priceStrComma = priceStr.replace('.', ',');
  match = allVariants.find(function(v) { var t = v.title.trim(); return t === priceStr || t === priceStrComma || t === priceEur.toString(); });
  if (match) return match;
  return null;
 }
 function fill(el, items, p) {
  el.innerHTML = '<option value="">' + p + '</option>';
  var unique = [];
  items.forEach(function(i) { if (i && unique.indexOf(i) === -1) unique.push(i); });
  unique.sort().forEach(function(i) { var o = document.createElement('option'); o.value = o.textContent = i; el.appendChild(o); });
  el.disabled = unique.length === 0; updateBorder(el);
 }
 function updateBorder(el) {
  var has = el.value !== "";
  el.classList.toggle('has-value', has);
  /* v4.11: Mini-Label ueber der Auswahl (.nc-field) */
  if (el.parentElement && el.parentElement.classList.contains('nc-field')) el.parentElement.classList.toggle('has-value', has);
 }
 function resetChildSelects(fromLevel) {
  [{el:mS,p:L.model,l:1},{el:eS,p:L.engine,l:2},{el:yS,p:L.year,l:3}].forEach(function(s) {
   if (s.l >= fromLevel) { s.el.innerHTML = '<option value="">'+s.p+'</option>'; s.el.disabled = true; s.el.value = ''; s.el.classList.remove('has-value'); if (s.el.parentElement && s.el.parentElement.classList.contains('nc-field')) s.el.parentElement.classList.remove('has-value'); }
  });
 }
 var URL_REGEX = /(https?:\/\/[^\s<>"']+)/i;
 function renderCriticalWarning(brand, model, spec) {
  var banner = document.getElementById('v-critical-banner'); var textEl = document.getElementById('v-critical-text'); var btnEl = document.getElementById('v-critical-btn');
  if (!banner || !textEl || !btnEl) return;
  var raw = getCritical(brand, model, spec);
  if (!raw) { banner.classList.add('nc-hide'); return; }
  var urlMatch = raw.match(URL_REGEX); var displayText = raw;
  if (urlMatch) { var url = urlMatch[1]; displayText = raw.replace(url, '').replace(/\s*[—–:,-]\s*$/, '').replace(/^\s*[—–-]\s+/, '').trim(); btnEl.href = url; btnEl.classList.remove('nc-hide'); }
  else { btnEl.href = '#'; btnEl.classList.add('nc-hide'); }
  if (displayText && !/[.!?]$/.test(displayText)) displayText += '.'; /* v4.13: Satzende nach entferntem Link */
  if (!displayText) displayText = L.critical_btn;
  textEl.textContent = displayText; banner.classList.remove('nc-hide');
 }
 function hideCriticalWarning() { var banner = document.getElementById('v-critical-banner'); if (banner) banner.classList.add('nc-hide'); }
 function ytId(u) {
  if (!u) return ''; u = String(u).trim();
  if (u.indexOf('watch?v=') !== -1) return u.split('watch?v=')[1].split('&')[0].split('#')[0];
  if (u.indexOf('youtu.be/') !== -1) return u.split('youtu.be/')[1].split('?')[0].split('&')[0].split('#')[0];
  if (u.indexOf('/embed/') !== -1) return u.split('/embed/')[1].split('?')[0].split('&')[0].split('#')[0];
  if (u.indexOf('/shorts/') !== -1) return u.split('/shorts/')[1].split('?')[0].split('&')[0].split('#')[0];
  return u;
 }

 /* ── Video mit YouTube-Facade (Player lädt erst beim Klick) ─────────── */
 var NC_VID_ID = '';
 var ytWarmed = false;
 function ytWarm() {
  if (ytWarmed) return; ytWarmed = true;
  ['https://www.youtube-nocookie.com','https://i.ytimg.com','https://www.google.com'].forEach(function(h) {
   var l = document.createElement('link'); l.rel = 'preconnect'; l.href = h; document.head.appendChild(l);
  });
 }
 function renderFacade() {
  var wrap = document.getElementById('v-video-wrap'), id = NC_VID_ID;
  if (!wrap || !id) return;
  wrap.innerHTML =
   '<button type="button" class="nc-facade">' +
     '<img class="nc-facade__thumb" width="1280" height="720" loading="lazy" decoding="async" alt="" ' +
          'src="https://i.ytimg.com/vi/' + id + '/sddefault.jpg" ' +
          'onerror="this.onerror=null;this.src=\'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg\';">' +
     '<span class="nc-facade__play" aria-hidden="true">' +
       '<svg viewBox="0 0 68 48" width="68" height="48"><path d="M66.52 7.74c-.78-2.93-2.49-5.41-5.42-6.19C55.79.13 34 0 34 0S12.21.13 6.9 1.55c-2.93.78-4.63 3.26-5.42 6.19C.06 13.05 0 24 0 24s.06 10.95 1.48 16.26c.78 2.93 2.49 5.41 5.42 6.19C12.21 47.87 34 48 34 48s21.79-.13 27.1-1.55c2.93-.78 4.64-3.26 5.42-6.19C67.94 34.95 68 24 68 24s-.06-10.95-1.48-16.26z" fill="#f00"/><path d="M45 24 27 14v20" fill="#fff"/></svg>' +
     '</span>' +
   '</button>';
  var b = wrap.querySelector('.nc-facade');
  b.setAttribute('aria-label', L.play);
  b.addEventListener('pointerover', ytWarm, { once: true, passive: true });
  b.addEventListener('click', playVideo);
 }
 function playVideo() {
  var wrap = document.getElementById('v-video-wrap'), id = NC_VID_ID;
  if (!wrap || !id) return;
  var f = document.createElement('iframe');
  f.className = 'nc-video-frame';
  f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?rel=0&modestbranding=1&autoplay=1&playsinline=1';
  f.title = 'NGM App';
  f.setAttribute('frameborder', '0');
  f.setAttribute('allow', 'accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture;web-share');
  f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
  f.setAttribute('allowfullscreen', '');
  wrap.innerHTML = ''; wrap.appendChild(f);
 }
 function renderVideo(url) {
  var box = document.getElementById('v-video-box');
  if (!box) return;
  NC_VID_ID = ytId(url);
  if (!NC_VID_ID) { hideVideo(); return; }
  box.classList.remove('nc-hide');
  renderFacade();
 }
 function hideVideo() {
  var box = document.getElementById('v-video-box'), wrap = document.getElementById('v-video-wrap');
  if (box) box.classList.add('nc-hide');
  if (wrap) wrap.innerHTML = '';
 }

 function ncChartAria(v){ var s=document.getElementById('nc-cv-svg'); if(!s||!v) return; var sp=Math.max(v.s_ps||0,v.s_ps_to||0), sn=Math.max(v.s_nm||0,v.s_nm_to||0); s.setAttribute('role','img'); s.setAttribute('aria-label', T('chart_title')+': '+T('stock')+' '+sp+' PS / '+sn+' Nm, Stage 1 '+(v.s1_ps||0)+' PS / '+(v.s1_nm||0)+' Nm, Stage 2 '+(v.s2_ps||0)+' PS / '+(v.s2_nm||0)+' Nm'); } /* v4.11 */
 function updateViz(){ if(!currentV||!document.getElementById('nc-cv-svg'))return; ncBuildRows(currentV); ncBuildLegend(); renderChart(currentV,activeMode,true); ncChartAria(currentV); }
 function syncGlobalState() {
  if (currentV && atcBtn.dataset.variantId) { window.__NGM_CONFIGURATOR = { active: true, variantId: parseInt(atcBtn.dataset.variantId, 10), vehicle: currentV.b + ' ' + currentV.m + ' ' + currentV.e + ' (' + yS.value + ')', lic: currentV.lic || '', adapter: (ncAdpActive() ? ncAdp.answer : null), vin: (ncEcuNeeded() ? ncEcu.vin : '') }; }
  else { window.__NGM_CONFIGURATOR = { active: false, variantId: null, vehicle: '', lic: '', adapter: null, vin: '' }; }
 }

 /* ═══════════════════════════════════════════════════════════════════════
    ADAPTER-FRAGE (v4.8)
    ───────────────────────────────────────────────────────────────────────
    Anlass: Lizenzen wurden ohne Adapter bestellt, der Drawer-Upsell wurde
    uebersehen; Bestandskunden mit Adapter sahen ihn trotzdem.
    Gate aktiv genau dann, wenn #nc-adp im DOM steht. Fehlt der Block
    (Upgrade-Produkt, Adapterprodukt nicht auffindbar), laeuft alles wie
    vor v4.8 (fail-open). Gate NUR ueber disabled + Klasse is-gated:
    dataset.variantId liest snippets/ngm-financing.liquid (PayPal-Betrag,
    ?variant= fuer Klarna) und syncGlobalState(), es bleibt unangetastet.
    Die Antwort ueberlebt einen Fahrzeugwechsel bewusst (resetV() fasst sie
    nicht an); dauerhaft aufgezeichnet wird sie als Cart-Attribut bzw. als
    Adapter-Position im Warenkorb.
    ═══════════════════════════════════════════════════════════════════════ */
 var NC_ADP_ATTR_KEY     = 'NGM Adapter';
 var NC_ADP_ATTR_YES     = 'Customer confirmed existing NGM adapter'; /* cart-drawer.liquid Zeile 364 vergleicht exakt diesen String */
 var NC_ADP_ATTR_MISSING = 'Customer needs adapter, not added (sold out)';
 var NC_ADP_ATTR_FAILED  = 'Customer needs adapter, not added (add failed)';
 var ncAdp = {
  el: document.getElementById('nc-adp'),
  answer: null, /* null | 'yes' | 'no' */
  variantId: parseInt(NC_CFG.adapter_variant_id, 10) || 0,
  available: NC_CFG.adapter_available === true,
  priceCents: parseInt(NC_CFG.adapter_price_cents, 10) || 0, /* v4.11: Markets-umgerechnet, aus der Section */
  owner: NC_CFG.adapter_owner === true,
  locked: false
 };
 function ncAdpActive() { return !!ncAdp.el; }
 function ncAdpReady()  { return !ncAdpActive() || ncAdp.answer === 'yes' || ncAdp.answer === 'no'; }
 function ncAdpLock(on) {
  ncAdp.locked = !!on;
  Array.prototype.forEach.call(document.querySelectorAll('[data-nc-adp]'), function(b){ b.disabled = !!on; }); /* v4.9: Karte + CTA-Kompaktfassung */
 }
 /* ═══ VORMERKEN (v4.13): coming_soon = true -> sichtbar, nicht kaufbar ═══ */
 function ncSoon() { return !!(currentV && currentV.soon === true); }
 function ncHandleize(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
 function ncSoonSyncUi() {
  var el = document.getElementById('nc-soon'); if (!el) return;
  var on = ncSoon();
  el.classList.toggle('nc-hide', !on);
  if (!on) return;
  var tags = document.getElementById('nc-soon-tags'), ret = document.getElementById('nc-soon-return');
  if (tags) tags.value = 'warteliste, warteliste:' + ncHandleize(currentV.b + ' ' + currentV.m);
  if (ret) {
   try {
    var u = new URL(location.pathname, location.origin);
    u.searchParams.set('brand', bS.value); u.searchParams.set('model', mS.value); u.searchParams.set('engine', eS.value); u.searchParams.set('year', yS.value);
    ret.value = u.pathname + u.search;
   } catch (e) { ret.value = location.pathname; }
  }
  /* Erfolg erkennen, unabhaengig davon, welche Parameter Shopify nach
     Captcha und Redirect noch anhaengt: vor dem Absenden merken wir uns
     Fahrzeug + Zeit (sessionStorage), nach dem Rueckweg zeigen wir die
     Bestaetigung, sofern Shopify keinen Formularfehler gerendert hat. */
  try {
   var key = ncHandleize(currentV.b + ' ' + currentV.m), posted = /[?&]customer_posted=true/.test(location.search);
   var raw = sessionStorage.getItem('ngm_soon_sent'), sent = raw ? JSON.parse(raw) : null;
   var fresh = sent && sent.k === key && (Date.now() - (sent.t || 0)) < 15 * 60 * 1000;
   if ((posted || fresh) && !document.querySelector('.nc-soon__err')) {
    var ok = document.getElementById('nc-soon-ok'), row = document.getElementById('nc-soon-row');
    if (ok) ok.classList.remove('nc-hide'); if (row) row.classList.add('nc-hide');
    sessionStorage.removeItem('ngm_soon_sent');
   }
  } catch (e) {}
 }
 (function(){
  var f = document.getElementById('nc-soon-form'); if (!f) return;
  f.addEventListener('submit', function(){
   try { if (currentV) sessionStorage.setItem('ngm_soon_sent', JSON.stringify({ k: ncHandleize(currentV.b + ' ' + currentV.m), t: Date.now() })); } catch (e) {}
  });
 })();
 function ncSoonNudge() {
  var el = document.getElementById('nc-soon'); if (!el || el.classList.contains('nc-hide')) return;
  try {
   var r = el.getBoundingClientRect(), vh = window.innerHeight || document.documentElement.clientHeight;
   if (r.top < 0 || r.bottom > vh) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
   el.classList.remove('is-highlight'); void el.offsetWidth; el.classList.add('is-highlight');
   clearTimeout(ncSoonNudge._t); ncSoonNudge._t = setTimeout(function(){ el.classList.remove('is-highlight'); }, 3200);
   var em = document.getElementById('nc-soon-email'); if (em) setTimeout(function(){ try { em.focus({ preventScroll: true }); } catch (e) {} }, 350);
  } catch (e) {}
 }
 document.addEventListener('click', function(e){
  if (!currentV || !ncSoon()) return;
  if (e.target && e.target.closest && e.target.closest('#nc-soon')) return;
  var t = e.target && e.target.closest ? e.target.closest('#v-sticky, #v-cta, #v-info-bar .nc-vehicle-bar-right') : null;
  if (t) ncSoonNudge();
 });

 /* ═══════════════════════════════════════════════════════════════════════
    FIN-PFLICHT + STEUERGERAET (v4.13)
    ───────────────────────────────────────────────────────────────────────
    Aktiv nur fuer Fahrzeuge mit ecu = true. Gate wie bei der Adapter-Frage
    ueber disabled + .is-gated (ncAdpSyncUi liest ncEcuReady()). Ohne
    kaufbares Steuergeraet-Produkt bleibt der Kauf gesperrt: lieber keine
    Bestellung als eine Lizenz, die ohne Steuergeraet nicht nutzbar ist.
    Die FIN ueberlebt Fahrzeugwechsel und Reload (sessionStorage).
    ═══════════════════════════════════════════════════════════════════════ */
 var NC_ECU_PROP = 'FIN / VIN';
 var ncEcu = {
  el: document.getElementById('nc-ecu'),
  input: document.getElementById('nc-ecu-vin'),
  msg: document.getElementById('nc-ecu-msg'),
  variantId: parseInt(NC_CFG.ecu_variant_id, 10) || 0,
  available: NC_CFG.ecu_available === true,
  priceCents: parseInt(NC_CFG.ecu_price_cents, 10) || 0,
  handle: NC_CFG.ecu_handle || '',
  vin: ''
 };
 function ncEcuNeeded() { return !!(currentV && currentV.ecu === true); }
 function ncVinClean(s) { return String(s == null ? '' : s).toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 17); }
 function ncVinValid(v) { return /^[A-HJ-NPR-Z0-9]{17}$/.test(v); }
 function ncEcuReady() { return !ncEcuNeeded() || ncSoon() || (ncEcu.available && ncEcu.variantId > 0 && ncVinValid(ncEcu.vin)); }
 function ncEcuInCart(cart, vin) {
  if (!cart || !cart.items || !ncEcu.variantId) return false;
  return cart.items.some(function(i){ return i.variant_id === ncEcu.variantId && i.properties && ncVinClean(i.properties[NC_ECU_PROP]) === vin; });
 }
 /* Block ein/aus, Feldzustand, Meldung. Gate und Preis macht ncAdpSyncUi. */
 function ncEcuSyncUi(touched) {
  if (!ncEcu.el) return;
  var need = ncEcuNeeded();
  ncEcu.el.classList.toggle('nc-hide', !need);
  var fld = ncEcu.el.querySelector('.nc-ecu__field'); if (fld) fld.classList.toggle('nc-hide', ncSoon()); /* Vormerken: FIN erst beim Kauf */
  if (ncEcu.input && ncEcu.input.value !== ncEcu.vin) ncEcu.input.value = ncEcu.vin;
  var ok = ncVinValid(ncEcu.vin), bad = !ok && (ncEcu.vin.length === 17 || (touched === true && ncEcu.vin.length > 0));
  if (ncEcu.input) { ncEcu.input.classList.toggle('is-ok', ok); ncEcu.input.classList.toggle('is-bad', bad); ncEcu.input.setAttribute('aria-invalid', bad ? 'true' : 'false'); }
  if (ncEcu.msg) {
   var key = ok ? 'ecu_ok' : (bad ? 'ecu_bad' : 'ecu_empty');
   ncEcu.msg.setAttribute('data-ngm-l10n', key);
   ncEcu.msg.textContent = T(key);
   ncEcu.msg.classList.toggle('is-ok', ok); ncEcu.msg.classList.toggle('is-bad', bad);
  }
  ncEcu.el.classList.toggle('is-open', need && !ncEcuReady());
  if (!ncAdpActive()) { /* ohne Adapter-Frage (fail-open-Fall) das Gate selbst setzen */
   var gated = !!currentV && !ncEcuReady();
   ncEachAtc(function(b){ if (b.classList.contains('is-loading')) return; if (currentV) b.disabled = gated; b.classList.toggle('is-gated', gated); });
   var eh = document.getElementById('v-cta-ecu-hint'); if (eh) eh.classList.toggle('nc-hide', !gated);
   var es = document.getElementById('nc-ecu-sticky'); if (es) es.classList.toggle('nc-hide', !gated);
   ncPriceSync(); syncGlobalState();
  }
 }
 function ncEcuNudge() {
  if (!ncEcu.el || ncEcu.el.classList.contains('nc-hide')) return;
  try {
   var r = ncEcu.el.getBoundingClientRect(), vh = window.innerHeight || document.documentElement.clientHeight;
   if (r.top < 0 || r.bottom > vh) ncEcu.el.scrollIntoView({ behavior: 'smooth', block: 'center' });
   ncEcu.el.classList.remove('is-highlight'); void ncEcu.el.offsetWidth; ncEcu.el.classList.add('is-highlight');
   clearTimeout(ncEcuNudge._t);
   ncEcuNudge._t = setTimeout(function(){ ncEcu.el.classList.remove('is-highlight'); }, 3200);
   if (ncEcu.input && ncEcu.available) setTimeout(function(){ try { ncEcu.input.focus({ preventScroll: true }); } catch (e) { ncEcu.input.focus(); } }, 350);
  } catch (e) {}
 }
 if (ncEcu.el && ncEcu.input) {
  try { ncEcu.vin = ncVinClean(sessionStorage.getItem('ngm_vin') || ''); } catch (e) {}
  if (ncEcu.vin) ncEcu.input.value = ncEcu.vin;
  if (!ncEcu.available) ncEcu.input.disabled = true;
  ncEcu.input.addEventListener('input', function(){
   ncEcu.vin = ncVinClean(ncEcu.input.value);
   try { sessionStorage.setItem('ngm_vin', ncEcu.vin); } catch (e) {}
   ncEcuSyncUi(false); if (ncAdpActive()) ncAdpSyncUi();
  });
  ncEcu.input.addEventListener('blur', function(){ ncEcuSyncUi(true); });
  ncEcu.input.addEventListener('keydown', function(e){ if (e.key === 'Enter') { e.preventDefault(); ncEcuSyncUi(true); if (ncEcuReady() && ncAdpReady() && !atcBtn.disabled) ncAtcClick.call(atcBtn); } });
  /* Gesperrte Kaufbuttons (pointer-events:none) -> Tipp faellt auf den
     Container durch. Adapter-Frage offen = deren Nudge, sonst zur FIN. */
  document.addEventListener('click', function(e){
   if (!currentV || !ncEcuNeeded() || ncEcuReady() || !ncAdpReady()) return;
   if (e.target && e.target.closest && e.target.closest('#nc-ecu, [data-nc-adp], #nc-adp-sticky')) return;
   var t = e.target && e.target.closest ? e.target.closest('#v-sticky, #v-cta, #v-info-bar .nc-vehicle-bar-right, [data-nc-ecu-go]') : null;
   if (t) ncEcuNudge();
  });
 }

 /* v4.11: Gesamtpreis inkl. Adapter. ncLicCents = Lizenzpreis in aktiver
    Waehrung (Cent), gesetzt in yS.onchange, null ohne Fahrzeug. */
 var ncLicCents = null;
 function ncPriceSync() {
  var subs = [document.getElementById('v-sel-price-sub'), document.getElementById('v-cta-price-sub')];
  var prices = [document.getElementById('v-sel-price'), document.getElementById('v-cta-price'), document.getElementById('v-sticky-price')];
  function hideSubs() { subs.forEach(function(s){ if (s) { s.classList.add('nc-hide'); s.textContent = ''; } }); }
  if (ncLicCents === null || !currentV) { hideSubs(); return; }
  var addAdp = ncAdpActive() && ncAdp.answer === 'no' && ncAdp.available && ncAdp.priceCents > 0;
  var addEcu = ncEcuNeeded() && ncEcu.available && ncEcu.priceCents > 0; /* v4.13 */
  var txt = ncFmt(ncLicCents + (addAdp ? ncAdp.priceCents : 0) + (addEcu ? ncEcu.priceCents : 0));
  prices.forEach(function(p){ if (p && p.textContent !== txt) p.textContent = txt; });
  /* v4.13: Preisaufstellung im FIN-Block (Lizenz + Steuergeraet = Gesamt, ohne Adapter) */
  if (addEcu) {
   var pl = document.getElementById('nc-ecu-p-lic'), pe = document.getElementById('nc-ecu-p-ecu'), pt = document.getElementById('nc-ecu-p-total');
   if (pl) pl.textContent = ncFmt(ncLicCents);
   if (pe) pe.textContent = ncFmt(ncEcu.priceCents);
   if (pt) pt.textContent = ncFmt(ncLicCents + ncEcu.priceCents);
  }
  if (!addAdp && !addEcu) { hideSubs(); return; }
  var sub;
  if (addAdp && !addEcu) sub = T('incl_adapter') + ' (' + ncFmt(ncAdp.priceCents) + ')';
  else {
   var parts = [];
   if (addAdp) parts.push(T('incl_adapter_short') + ' (' + ncFmt(ncAdp.priceCents) + ')');
   if (addEcu) parts.push(T('incl_ecu') + ' (' + ncFmt(ncEcu.priceCents) + ')');
   sub = T('incl') + ' ' + parts.join(' + ');
  }
  subs.forEach(function(s){ if (!s) return; if (s.textContent !== sub) s.textContent = sub; s.classList.remove('nc-hide'); });
 }
 /* v4.11: Nach einer manuellen Wahl das Ergebnis ins Bild holen. Ziel ist die
    offene Adapter-Frage, sonst die Fahrzeugleiste. Nur scrollen, wenn das
    Ziel nicht komplett sichtbar ist; Abstand = Hoehe des fixen Headers. */
 var NC_PREFILLING = false;
 function ncRevealSelection() {
  setTimeout(function () {
   try {
    var target = (ncAdpActive() && !ncAdpReady() && !ncAdp.el.classList.contains('nc-hide')) ? ncAdp.el
               : (ncSoon() && document.getElementById('nc-soon')) ? document.getElementById('nc-soon')
               : (ncEcu.el && ncEcuNeeded() && !ncEcuReady() && !ncEcu.el.classList.contains('nc-hide')) ? ncEcu.el /* v4.13 */
               : document.getElementById('v-info-bar');
    if (!target || target.classList.contains('nc-hide')) return;
    var r = target.getBoundingClientRect(), vh = window.innerHeight || document.documentElement.clientHeight;
    var hdr = document.querySelector('.shopify-section--header');
    var off = (hdr ? hdr.getBoundingClientRect().height : 0) + 16;
    if (r.top >= off && r.bottom <= vh) return;
    var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    window.scrollTo({ top: Math.max(0, r.top + window.pageYOffset - off), behavior: reduce ? 'auto' : 'smooth' });
   } catch (e) {}
  }, 80);
 }
 function ncAdpSyncUi() {
  if (!ncAdpActive()) return;
  try {
   Array.prototype.forEach.call(document.querySelectorAll('[data-nc-adp]'), function(b){
    var on = ncAdp.answer === b.getAttribute('data-nc-adp');
    b.classList.toggle('is-on', on);
    b.setAttribute('aria-checked', on ? 'true' : 'false');
   }); /* v4.9: Karte und CTA-Kompaktfassung teilen den Zustand */
   var soon = ncSoon(), ready = ncAdpReady() || soon, ecuReady = ncEcuReady(), gated = !!currentV && (!ready || !ecuReady); /* v4.13: FIN sperrt mit, Vormerken sperrt ohne Nudge */
   ncAdp.el.classList.toggle('is-open', !ready); /* v4.9: unbeantwortet = Aufmerksamkeits-Glow */
   var stBar = document.getElementById('v-sticky'); if (stBar) stBar.classList.toggle('is-gated', gated);
   if (document.body) document.body.classList.toggle('nc-sticky-gated', gated); /* v4.10: hoehere Leiste, Abstand am Seitenende (CSS in der Handy-Media-Query) */
   var stAsk = document.getElementById('nc-adp-sticky'); if (stAsk) stAsk.classList.toggle('nc-hide', !(!!currentV && !ready)); /* v4.10: Frage in der Leiste, solange gesperrt */
   var stEcu = document.getElementById('nc-ecu-sticky'); if (stEcu) stEcu.classList.toggle('nc-hide', !(!!currentV && ready && !ecuReady)); /* v4.13 */
   setTimeout(function(){ if (typeof ncLiftOverlays === 'function') ncLiftOverlays(); }, 30); /* v4.11: Leistenhoehe aendert sich mit der Antwort */
   ncEachAtc(function(b){
    if (b.classList.contains('is-loading')) return;
    if (currentV) b.disabled = gated || soon;
    b.classList.toggle('is-gated', gated);
    b.classList.toggle('is-soon', soon); /* v4.13 */
   });
   var hint = document.getElementById('v-cta-adp-hint');
   if (hint) hint.classList.toggle('nc-hide', !(!!currentV && !ready));
   var ehint = document.getElementById('v-cta-ecu-hint'); if (ehint) ehint.classList.toggle('nc-hide', !(!!currentV && !ecuReady)); /* v4.13 */
   ncPriceSync(); /* v4.11: Gesamtpreis folgt der Antwort */
   syncGlobalState();
  } catch (e) { console.warn('[NGM] Adapter-Frage UI:', e); }
 }
 function ncAdpSet(answer) {
  if (!ncAdpActive() || ncAdp.locked) return;
  ncAdp.answer = (answer === 'yes' || answer === 'no') ? answer : null;
  ncAdpSyncUi();
  /* Kurzer Hinweis auf den nun freien Kaufbutton (gleiche Animation wie autoPrefill) */
  if (currentV && ncAdpReady() && !atcBtn.disabled && !atcBtn.classList.contains('is-no-match')) {
   ncEachAtc(function(b){ b.classList.remove('is-highlight'); void b.offsetWidth; b.classList.add('is-highlight'); }); /* v4.9: auch CTA-Button */
  }
 }
 function ncAdpNudge(scroll) {
  if (!ncAdpActive()) return;
  try {
   if (scroll !== false) {
    var r = ncAdp.el.getBoundingClientRect(), vh = window.innerHeight || document.documentElement.clientHeight;
    if (r.top < 0 || r.bottom > vh) ncAdp.el.scrollIntoView({ behavior: 'smooth', block: 'center' });
   }
   ncAdp.el.classList.remove('is-highlight'); void ncAdp.el.offsetWidth; ncAdp.el.classList.add('is-highlight');
   clearTimeout(ncAdpNudge._t);
   ncAdpNudge._t = setTimeout(function(){ ncAdp.el.classList.remove('is-highlight'); }, 3200);
  } catch (e) {}
 }
 if (ncAdpActive()) {
  document.addEventListener('click', function(e){ /* v4.9: auch #nc-adp-cta im Abschluss-CTA */
   var b = e.target && e.target.closest ? e.target.closest('[data-nc-adp]') : null;
   if (!b || b.disabled) return;
   ncAdpSet(b.getAttribute('data-nc-adp'));
  });
  /* Gesperrte Kaufbuttons feuern keinen click. .is-gated setzt
     pointer-events:none, der Tipp faellt auf den Container durch und
     fuehrt zur Frage. #v-sticky liegt ausserhalb von root, deshalb
     ein Listener auf document. */
  document.addEventListener('click', function(e){
   if (!currentV || ncAdpReady()) return;
   if (e.target && e.target.closest && e.target.closest('[data-nc-adp], #nc-adp-sticky')) return; /* v4.9/v4.10: Antwort im CTA oder in der Leiste ist kein Nudge */
   var t = e.target && e.target.closest ? e.target.closest('#v-sticky, #v-cta, #v-info-bar .nc-vehicle-bar-right') : null;
   if (t) ncAdpNudge();
  });
  /* Eingeloggte Adapter-Besitzer: Ja vorbelegen (Notiz rendert Liquid),
     bleibt umschaltbar. Laeuft synchron VOR autoPrefill (DOMContentLoaded
     bzw. 50 ms), damit ein vorbelegtes Fahrzeug sofort kaufbar ist. */
  if (ncAdp.owner) ncAdp.answer = 'yes';
  ncAdpSyncUi();
 }
 fill(bS, data.map(function(d){return d.b;}), L.brand);
 bS.onchange = function() { resetChildSelects(1); updateBorder(bS); resetV(); if(bS.value){fill(mS,data.filter(function(d){return d.b===bS.value;}).map(function(d){return d.m;}),L.model);mS.disabled=false;} };
 mS.onchange = function() { resetChildSelects(2); updateBorder(mS); resetV(); if(mS.value){fill(eS,data.filter(function(d){return d.b===bS.value&&d.m===mS.value;}).map(function(d){return d.e;}),L.engine);eS.disabled=false;} };
 eS.onchange = function() {
  resetChildSelects(3); updateBorder(eS); resetV();
  if(eS.value){ var ys=[]; data.filter(function(d){return d.b===bS.value&&d.m===mS.value&&d.e===eS.value;}).forEach(function(v){var s=Math.min(v.yf,v.yt),e=Math.max(v.yf,v.yt);for(var i=s;i<=e;i++)if(i>1900)ys.push(String(i));}); var u=[]; ys.forEach(function(y){if(u.indexOf(y)===-1)u.push(y);}); fill(yS,u,L.year); yS.disabled=false; }
 };
 yS.onchange = function() {
  updateBorder(yS);
  currentV = data.find(function(d) { return d.b===bS.value&&d.m===mS.value&&d.e===eS.value&&parseInt(yS.value)>=Math.min(d.yf,d.yt)&&parseInt(yS.value)<=Math.max(d.yf,d.yt); });
  if (!currentV) return;
  /* v4.7.2: Fahrzeug bei JEDER Auswahl merken. Vorher stand das nur in
     autoPrefill() — gespeichert wurde also ausschliesslich, was ohnehin
     schon im Speicher lag oder per URL kam. Wer sich manuell durchklickte,
     wurde nie gemerkt; die 24-Stunden-Erinnerung lief damit praktisch leer.
     Darauf baut auch der Abschluss-CTA auf ("Weiter mit deinem Fahrzeug"). */
  try {
   localStorage.setItem('ngm_vehicle', JSON.stringify({
    brand: bS.value, model: mS.value, engine: eS.value, year: yS.value, ts: Date.now()
   }));
  } catch (e) {}
  /* v4.7.3: Fahrzeug-Parameter aus der URL entfernen, sobald eine Auswahl
     steht. getPrefill() bevorzugt die URL vor dem Speicher — nach einem
     Sprachwechsel (behaelt die Query) kam sonst das Auto aus dem Werbelink
     zurueck statt der eigenen Auswahl. */
  try {
   var u = new URL(location.href);
   ['brand','model','engine','year'].forEach(function(k){ u.searchParams.delete(k); });
   history.replaceState(null, '', u.pathname + (u.searchParams.toString() ? '?' + u.searchParams.toString() : '') + u.hash);
  } catch (e) {}
  document.getElementById('v-info-bar').classList.remove('nc-hide');
  if (ncAdp.el) ncAdp.el.classList.toggle('nc-hide', ncSoon()); /* v4.8: Adapter-Frage im Gleichschritt mit der Fahrzeugleiste; v4.13: nicht beim Vormerken */
  document.getElementById('v-sel-name').textContent = currentV.b+" "+currentV.m;
  document.getElementById('v-sel-engine').textContent = currentV.e+" · "+yS.value;
  var matchedVariant = findVariantByPrice(currentV.p);
  /* Preis der gefundenen Variante ist von Shopify korrekt umgerechnet und
     entspricht exakt dem Warenkorb. Nur ohne Variante behelfen wir uns mit
     dem umgerechneten Metaobjekt-Preis. */
  document.getElementById('v-sel-price').textContent =
    matchedVariant ? ncFmt(matchedVariant.price) : ncFmtConverted(currentV.p);
  ncLicCents = matchedVariant ? Number(matchedVariant.price) : Math.round((Number(currentV.p) || 0) * NC_FX); /* v4.11 */
  ncEachAtc(function(b){
   b.disabled = !ncAdpReady() || !ncEcuReady() || ncSoon(); /* v4.8: Kaufen erst nach der Adapter-Frage, v4.13: und mit FIN, nie beim Vormerken */
   b.classList.toggle('is-no-match',!matchedVariant);
   b.querySelector('.nc-atc-label').textContent = matchedVariant ? (ncSoon() ? L.soon_atc : L.addcart) : L.pricena; /* v4.13 */
   b.dataset.variantId = matchedVariant ? matchedVariant.id : '';
  });
  /* Abschluss-CTA unten: Fahrzeug und Preis spiegeln, damit man vor dem
     Klick nicht nach oben scrollen muss, um zu sehen, was man kauft. */
  var ctaBox=document.getElementById('v-cta'),
      ctaName=document.getElementById('v-cta-name'),
      ctaPrice=document.getElementById('v-cta-price');
  if(ctaName) ctaName.textContent=currentV.b+' '+currentV.m+' · '+currentV.e+' · '+yS.value;
  if(ctaPrice) ctaPrice.textContent=document.getElementById('v-sel-price').textContent;
  if(ctaBox) ctaBox.classList.remove('nc-hide');
  /* Sticky-Leiste mitfuellen. Kuerzerer Text als im CTA — die Leiste ist
     einzeilig und schneidet sonst mitten im Motor ab. */
  var stName=document.getElementById('v-sticky-name'),
      stPrice=document.getElementById('v-sticky-price');
  if(stName) stName.textContent=currentV.b+' '+currentV.m+' · '+currentV.e;
  if(stPrice) stPrice.textContent=document.getElementById('v-sel-price').textContent;
  ncStickyApply();
  ncSoonSyncUi(); ncEcuSyncUi(false); /* v4.13: Vormerken + FIN-Block vor dem Gate */
  syncGlobalState(); ncAdpSyncUi(); /* v4.8: is-gated, CTA-Hinweis, Sticky-Text */
  var hint=document.getElementById('v-hint');if(hint)hint.classList.add('nc-hide');
  var fGrid=document.getElementById('v-features-grid');
  fGrid.classList.remove('is-open');
  fGrid.innerHTML=currentV.f.map(function(f){return '<div class="nc-feat-item"><div class="nc-feat-ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg></div><div class="nc-feat-name">'+f+'</div><div class="nc-feat-status">'+L.active+'</div></div>';}).join('');
  document.getElementById('nc-feat-count').textContent=currentV.f.length+' '+L.count;
  var warnBox=document.getElementById('v-warn-box');
  if(currentV.notes&&currentV.notes.trim().length>1){document.getElementById('v-warn-content').textContent=currentV.notes.replace(/^\s*(Hinweis|Note|Notice|Achtung)\s*:\s*/i,'');warnBox.classList.remove('nc-hide');}else{warnBox.classList.add('nc-hide');}
  document.getElementById('v-features-box').classList.remove('nc-hide');
  renderVideo(currentV.yt_url);
  var tBtn=document.getElementById('v-feature-toggle');
  if(currentV.f.length>4){tBtn.style.display='block';tBtn.textContent=L.showall;}else{tBtn.style.display='none';fGrid.classList.add('is-open');}
  renderCriticalWarning(currentV.b, currentV.m, currentV.spec); /* v4.13 */
  updateViz(); syncProps();
  if (!NC_PREFILLING) ncRevealSelection(); /* v4.11 */
 };
 document.getElementById('v-feature-toggle').addEventListener('click',function(){var g=document.getElementById('v-features-grid');var o=g.classList.toggle('is-open');this.textContent=o?L.showless:L.showall;});
 function syncProps() {
  if(!currentV)return;
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form){
   function add(n,v){var i=form.querySelector('input[name="properties['+n+']"]');if(!i){i=document.createElement('input');i.type='hidden';i.name='properties['+n+']';form.appendChild(i);}i.value=v;}
   add('Vehicle',currentV.b+" "+currentV.m+" "+currentV.e+" ("+yS.value+")");
   add('_License Code',currentV.lic||"");
  });
 }
 /* ═══════════════════════════════════════════════════════════════════════
    WARENKORB (v4.4) — identisches Verhalten auf Android, iOS und Windows
    ───────────────────────────────────────────────────────────────────────
    Vorher lief hier ein eigener Fetch, der den Android-Fix aus Cart-Drawer
    v4.7 komplett umging. Drei Ursachen, alle behoben:

      a) cart.js wurde ohne cache:'no-store' und ohne Cache-Buster geholt.
         Android- und Windows-Browser durften die Antwort aus dem Cache
         bedienen — lag dort der Stand von vorher (leerer Warenkorb), zeigte
         der Drawer "Your cart is empty". Im Inkognito nie, weil kein Cache.
      b) Es wurde 'cart:refresh' gefeuert. Impacts _onCartRefresh() holt den
         Drawer per GET ohne Cache-Sperre — dieselbe Ursache ein zweites Mal.
      c) Die POST-Antwort von cart/add.js kann das fertige Drawer-HTML
         mitliefern ('sections'). POST-Antworten werden nie zwischen-
         gespeichert. Das blieb ungenutzt.

    Jetzt: sections anfordern, alles mit no-store + Cache-Buster, und
    'cart:change' MIT cart.sections feuern — der Weg, den Impacts
    _onCartChanged() erwartet. 'cart:refresh' nur noch als Rückfall.
    ═══════════════════════════════════════════════════════════════════════ */
 function ngmCfgRoot() {
  return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
 }
 function ngmCfgDrawer() {
  return document.querySelector('cart-drawer') || document.getElementById('cart-drawer');
 }
 /* v4.6: Die Section-ID ist der Angelpunkt fuer "Warenkorb bleibt leer".
    Ohne sie fordert ngmCfgAddToCart() keine 'sections' an, die Antwort
    enthaelt kein Drawer-HTML, und ngmCfgUpdateAndOpen() faellt auf den
    ungecachten GET des Themes zurueck — genau der, der aus dem Browser-
    Cache einen LEEREN Warenkorb liefern kann. Im privaten Fenster faellt
    das nie auf, weil dort kein Cache existiert.

    Das Attribut section-id kommt aus {{ section.id }} im Drawer-Markup.
    Der Drawer ist bei uns ein SNIPPET — wird es per {% render %} eingebunden,
    ist der section-Kontext nicht vererbt und das Attribut bleibt LEER.
    Deshalb zusaetzlich der Wrapper-Fallback: Shopify verpackt jede Section
    in <div id="shopify-section-<id>">. */
 /* Section, aus der Impact die "hinzugefuegt"-Ansicht rendert. Steht als
    eigene Datei im Theme (sections/variant-added.liquid); der Schluessel in
    cart.sections ist derselbe Name. */
 var NC_SECTION_VARIANT_ADDED = 'variant-added';

 /* Sections additiv an das cart-Objekt haengen. Additiv, weil sie aus zwei
    Quellen kommen koennen: der POST-Antwort von cart/add.js und dem eigenen
    Nachladen der Drawer-Section. Ein einfaches Zuweisen wuerde die jeweils
    andere Quelle ueberschreiben — und damit womoeglich 'variant-added'. */
 function ncMergeSections(cart, sec) {
  if (!cart || !sec) return;
  cart.sections = cart.sections || {};
  for (var k in sec) {
   if (Object.prototype.hasOwnProperty.call(sec, k)) cart.sections[k] = sec[k];
  }
 }

 function ngmCfgSectionId() {
  var d = ngmCfgDrawer();
  if (!d) return '';
  var attr = d.getAttribute('section-id');
  if (attr) return attr;
  var wrap = d.closest ? d.closest('[id^="shopify-section-"]') : null;
  if (wrap && wrap.id) return wrap.id.replace(/^shopify-section-/, '');
  if (!ngmCfgSectionId._warned) {
   ngmCfgSectionId._warned = true;
   console.warn('[NGM] Section-ID des Cart-Drawers nicht ermittelbar — Warenkorb kann aus dem Browser-Cache leer erscheinen.');
  }
  return '';
 }

 /* Legt in den Warenkorb und lässt das Drawer-HTML gleich mitschicken.
    Nutzt window.NGM_CART.add(), falls der Cart-Drawer das bereitstellt —
    sonst die eigene, gleich gehärtete Implementierung. So bleibt der
    Konfigurator unabhängig von der Ladereihenfolge der beiden Dateien. */
 function ngmCfgAddToCart(items) {
  if (window.NGM_CART && typeof window.NGM_CART.add === 'function') {
   return window.NGM_CART.add(items);
  }
  /* v4.6.3: ZWEI Sections anfordern, nicht nur die des Drawers.
     Impacts _onVariantAdded() (theme.js) liest
       event.detail.cart.sections['variant-added']
     — eine eigene Section, die die "hinzugefuegt"-Ansicht rendert. Wir
     hatten immer nur die Drawer-Section angefordert, dieser Schluessel
     fehlte also und es flog:
       can't access property "variant-added", event.detail.cart.sections is undefined
     Der Name 'variant-added' ist der Section-Dateiname im Theme, deshalb
     hier fest verdrahtet. */
  var payload = { items: items };
  var wanted = [];
  var sid = ngmCfgSectionId();
  if (sid) wanted.push(sid);
  wanted.push(NC_SECTION_VARIANT_ADDED);
  payload.sections = wanted;
  payload.sections_url = window.location.pathname;
  return fetch(ngmCfgRoot() + 'cart/add.js', {
   method: 'POST',
   headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
   cache: 'no-store',
   body: JSON.stringify(payload)
  }).then(function(res) {
   if (!res.ok) throw new Error('Cart error ' + res.status);
   return res.json();
  });
 }

 /* v4.8: Cart-Attribut der Adapter-Frage. Wird VOR cart/add.js geschrieben,
    weil Shopify das Drawer-HTML in der POST-Antwort zum Add-Zeitpunkt
    rendert und cart-drawer.liquid Zeile 364 das Attribut sonst erst beim
    naechsten Rendern sieht. Leerer Wert loescht den Schluessel (Shopify-
    Konvention, so macht es auch ngmConsentSpeichern im Drawer). Shopify
    merged Attribute schluesselweise, die Consent-Attribute bleiben unberuehrt.
    Rejected NIE und wartet hoechstens 4 s: ein haengender Attribut-Request
    darf den Lizenzkauf nicht aufhalten. Rueckgabe: das Cart-JSON, das
    cart/update.js ohnehin liefert (ncAtcClick prueft darin, ob schon ein
    Adapter im Warenkorb liegt), oder null bei Fehler/Timeout. */
 function ncAdpWriteAttr(value) {
  if (!ncAdpActive()) return Promise.resolve(null);
  var attrs = {}; attrs[NC_ADP_ATTR_KEY] = value || '';
  var req = fetch(ngmCfgRoot() + 'cart/update.js', {
   method: 'POST',
   headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
   cache: 'no-store',
   body: JSON.stringify({ attributes: attrs })
  }).then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; });
  var late = new Promise(function(res){ setTimeout(function(){ res(null); }, 4000); });
  return Promise.race([req, late]);
 }

 /* v4.8: Liegt der Adapter schon im Warenkorb (frueherer Kauf mit Nein,
    Drawer-Upsell, zweite Lizenz fuers gleiche Auto)? Bei unlesbarem Cart
    (null) vorsichtshalber false, dann greift der Zwei-Positionen-Fallback. */
 function ncAdpInCart(cart) {
  if (!cart || !cart.items || !ncAdp.variantId) return false;
  return cart.items.some(function(i){ return i.variant_id === ncAdp.variantId; });
 }

 /* Drawer aktualisieren und öffnen. */
 function ngmCfgUpdateAndOpen(addedData) {
  var sid = ngmCfgSectionId();
  var sections = (addedData && addedData.sections) || null;

  return fetch(ngmCfgRoot() + 'cart.js?ts=' + Date.now(), { cache: 'no-store' })
   .then(function(r) { return r.json(); })
   .then(function(cart) {
    /* v4.6.3: Die aus cart/add.js gelieferten Sections IMMER an cart haengen,
       auch wenn die Drawer-Section fehlt — darin steckt 'variant-added', das
       _onVariantAdded() weiter unten braucht. Vorher wurde cart.sections nur
       gesetzt, wenn sec[sid] existierte; fehlte der Drawer, fehlte damit auch
       'variant-added' und der TypeError kam zurueck.
       Der Rueckgabewert sagt nur, ob DRAWER-HTML dabei war.
       Das Feld baseEvent:'variant:add' unten ist reine Nutzlast fuer Impacts
       _onCartChanged, kein Event. */
    function ncEmitChange(sec) {
     ncMergeSections(cart, sec);
     document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true, detail: { cart: cart, baseEvent: 'variant:add' }
     }));
     return !!(sec && sid && sec[sid]);
    }

    /* Die Sections aus der POST-Antwort vorab uebernehmen. Sie enthalten
       'variant-added' auch dann, wenn die Drawer-Section nicht dabei ist. */
    if (sections) ncMergeSections(cart, sections);

    /* Liefert ein Promise, das erfuellt ist, sobald der Drawer-Inhalt steht.
       WICHTIG: jeder Zweig muss hier durch — das Oeffnen haengt daran. */
    function ncRefreshDrawer() {
     if (sections && sid && sections[sid]) {
      /* Der saubere Weg: Impact rendert aus dem mitgelieferten HTML. */
      return Promise.resolve(ncEmitChange(sections));
     }
     /* v4.6: Rückfall NICHT mehr über 'cart:refresh'. Das löst den GET des
        Themes aus, den wir nicht mit cache:'no-store' versehen können — und
        genau der darf aus dem Browser-Cache einen leeren Warenkorb liefern.
        Stattdessen holen wir das Drawer-HTML selbst, gehärtet. */
     if (sid) {
      var url = window.location.pathname + '?section_id=' + encodeURIComponent(sid) + '&ts=' + Date.now();
      return fetch(url, { cache: 'no-store' })
       .then(function(r) { return r.ok ? r.text() : null; })
       .then(function(html) {
        var s = null;
        if (html) { s = {}; s[sid] = html; }
        return ncEmitChange(s);
       })
       .catch(function() { return ncEmitChange(null); });
     }
     /* Letzter Ausweg, wenn nicht einmal die Section-ID auffindbar ist. */
     document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
     return Promise.resolve(false);
    }

    return ncRefreshDrawer().then(function(hasSections) {
     if (!hasSections) {
      console.warn('[NGM] Drawer ohne Section-HTML aktualisiert — Inhalt kam nur aus cart.js.');
     }
     /* Erst öffnen, wenn der Inhalt steht — _onCartChanged setzt das
        innerHTML in einem setTimeout(0), daher ein kurzer Versatz. */
     setTimeout(function() {
      /* ══════════════════════════════════════════════════════════════════
         v4.6.3 — 'variant:add' wieder aktiv, jetzt mit der richtigen Section
         ──────────────────────────────────────────────────────────────────
         Impacts _onVariantAdded() liest cart.sections['variant-added'].
         Bis v4.6.0 haben wir nur die Drawer-Section angefordert, der
         Schluessel fehlte also — daher der TypeError, der den Listener
         mitten im Aktualisieren abbrechen liess und den Drawer leer stehen
         liess. Seit ngmCfgAddToCart() beide Sections anfordert, ist er da.
         Die Pruefung bleibt trotzdem: liefert Shopify die Section wider
         Erwarten nicht, lassen wir das Event lieber weg, als das Theme
         erneut in denselben Fehler laufen zu lassen. Der Drawer wird
         darunter ohnehin von uns geoeffnet.
         ══════════════════════════════════════════════════════════════════ */
      if (cart.sections && cart.sections[NC_SECTION_VARIANT_ADDED]) {
       document.dispatchEvent(new CustomEvent('variant:add', {
        bubbles: true, detail: { items: addedData.items || [addedData], cart: cart }
       }));
      } else {
       console.warn('[NGM] Section "' + NC_SECTION_VARIANT_ADDED + '" fehlt — variant:add wird uebersprungen.');
      }
      var d = ngmCfgDrawer();
      if (d && typeof d.show === 'function') { d.show(); return; }
      var trigger = document.querySelector('[aria-controls*="cart"][aria-controls*="drawer"]') ||
                    document.querySelector('a[href*="/cart"] .header__cart') ||
                    document.querySelector('.header__icon-wrapper[aria-controls]') ||
                    document.querySelector('[data-action="toggle-mini-cart"]') ||
                    document.querySelector('.cart-toggle') ||
                    document.querySelector('.header a[href="/cart"]');
      if (trigger) trigger.click();
     }, 60);
     return cart;
    });
   });
 }

 /* v4.6: derselbe Handler haengt an BEIDEN Kaufbuttons. Die Zustaende gehen
    ueber ncEachAtc an beide — sonst meldet der geklickte "Hinzugefuegt", der
    andere steht weiter auf "In den Warenkorb". Der Doppelklick-Schutz prueft
    ebenfalls beide, ein zweiter Klick auf den ANDEREN Button waehrend des
    laufenden Requests wuerde sonst doppelt in den Warenkorb legen. */
 function ncAtcClick() {
  if (!currentV) return;
  /* v4.8: Adapter-Frage ist Pflicht. Die Buttons sind zwar disabled, aber
     ein programmatischer Klick (Formular-Umleitung, Rest nach bfcache) darf
     nie ohne Antwort posten. */
  if (!ncAdpReady()) { ncAdpNudge(); return; }
  if (ncSoon()) { ncSoonNudge(); return; } /* v4.13: Vormerken, kein Kauf */
  if (!ncEcuReady()) { ncEcuNudge(); return; } /* v4.13 */
  var useVariantId = parseInt(this.dataset.variantId, 10);
  if (!useVariantId) { alert(L.novariant + ' ' + ncFmtConverted(currentV.p) + '.'); return; }
  if (atcBtns.some(function(b){ return b.classList.contains('is-loading'); })) return;
  ncEachAtc(function(b){ b.classList.add('is-loading'); b.classList.remove('is-highlight'); });
  ncAdpLock(true);

  /* v4.8: Antwort JETZT einfrieren; die Antwort-Buttons sind waehrend des
     Requests gesperrt, Payload und Attribut haengen trotzdem nicht am
     Live-Zustand. Nein = Adapter UND Lizenz in EINEM cart/add.js (ein
     sections-Payload, ein cart:change, ein show()); Ja = nur Lizenz plus
     Attribut. Reihenfolge bei Nein: Adapter zuerst, Lizenz zuletzt, weil
     Shopify zuletzt Hinzugefuegtes nach oben sortiert und die Lizenz oben
     im Drawer stehen soll. */
  var answer = ncAdpActive() ? ncAdp.answer : null;
  var vehName = currentV.b + ' ' + currentV.m + ' ' + currentV.e + ' (' + yS.value + ')';
  var licenseItem = {
   id: useVariantId,
   quantity: 1,
   properties: {
    'Vehicle': vehName,
    '_License Code': currentV.lic || ''
   }
  };
  /* v4.13: Steuergeraet als eigene Position VOR der Lizenz (Lizenz bleibt
     oben im Drawer), FIN an beiden Positionen. */
  var withEcu = ncEcuNeeded(), ecuItem = null;
  if (withEcu) {
   licenseItem.properties[NC_ECU_PROP] = ncEcu.vin;
   ecuItem = { id: ncEcu.variantId, quantity: 1, properties: {} };
   ecuItem.properties['Vehicle'] = vehName;
   ecuItem.properties[NC_ECU_PROP] = ncEcu.vin;
  }
  var items = ecuItem ? [ecuItem, licenseItem] : [licenseItem];
  var attrValue = '', withAdapter = false, attrOk = true;
  var wantAdapter = answer === 'no' && !!ncAdp.variantId && ncAdp.available;
  if (answer === 'yes') {
   attrValue = NC_ADP_ATTR_YES;
  } else if (answer === 'no' && !wantAdapter) {
   attrValue = NC_ADP_ATTR_MISSING;
  }

  ncAdpWriteAttr(attrValue)
  .then(function(cart) {
   attrOk = !ncAdpActive() || !!cart;
   /* v4.8: Die Antwort ueberlebt Fahrzeugwechsel und einen geschlossenen
      Drawer. Liegt der Adapter schon im Warenkorb (zweiter Kauf, Sound-
      Lizenz fuers gleiche Auto, Drawer-Upsell), nur die Lizenz nachlegen,
      sonst landen zwei Adapter im Warenkorb. Nur wenn das Cart-JSON nicht
      lesbar war, bleibt der Zwei-Positionen-Add als Fallback. */
   if (ecuItem && ncEcuInCart(cart, ncEcu.vin)) { ecuItem = null; items = [licenseItem]; } /* v4.13: gleiche FIN liegt schon drin */
   if (wantAdapter && !ncAdpInCart(cart)) {
    items = [{ id: ncAdp.variantId, quantity: 1 }].concat(items);
    withAdapter = true;
   }
   return ngmCfgAddToCart(items);
  })
  .catch(function(err) {
   /* v4.8: Shopify legt bei items[] alles oder nichts. Ist der Adapter
      zwischen Seitenaufruf und Klick ausverkauft, kommt 422 und auch die
      Lizenz fehlt. Dann genau einmal nur mit der Lizenz wiederholen und
      den Grund als Attribut hinterlassen, damit der Support nachfasst. */
   if (withAdapter && /\b422\b/.test(String(err && err.message))) {
    withAdapter = false;
    attrValue = NC_ADP_ATTR_FAILED;
    return ncAdpWriteAttr(attrValue).then(function(cart) { attrOk = !!cart; return ngmCfgAddToCart(ecuItem ? [ecuItem, licenseItem] : [licenseItem]); }); /* v4.13: Steuergeraet bleibt */
   }
   throw err;
  })
  .then(function(addedData) {
   ncAdpLock(false);
   ncEachAtc(function(b){
    b.classList.remove('is-loading');
    b.classList.add('is-added');
    b.querySelector('.nc-atc-label').textContent = L.added;
   });
   ngmCfgUpdateAndOpen(addedData);
   /* Attribut-Request war zu langsam oder fehlgeschlagen: einmal nachschieben, ohne zu warten */
   if (!attrOk && ncAdpActive()) ncAdpWriteAttr(attrValue);
   setTimeout(function() {
    ncEachAtc(function(b){
     b.classList.remove('is-added');
     b.querySelector('.nc-atc-label').textContent = L.addcart;
    });
   }, 2500);
  })
  .catch(function(err) {
   console.error('NGM ATC Error:', err);
   ncAdpLock(false);
   ncEachAtc(function(b){
    b.classList.remove('is-loading');
    b.querySelector('.nc-atc-label').textContent = L.error;
   });
   setTimeout(function() {
    ncEachAtc(function(b){ b.querySelector('.nc-atc-label').textContent = L.addcart; });
   }, 3000);
  });
 }
 ncEachAtc(function(b){ b.addEventListener('click', ncAtcClick); });
 var btnBoth=document.getElementById('btn-both'),btnPower=document.getElementById('btn-power'),btnTorque=document.getElementById('btn-torque');
 function ncSetMode(m,btn){[btnBoth,btnPower,btnTorque].forEach(function(b){if(b){b.classList.remove('on');b.setAttribute('aria-pressed','false');}});btn.classList.add('on');btn.setAttribute('aria-pressed','true');activeMode=m;if(currentV)renderChart(currentV,activeMode,false);}
 if(btnBoth)btnBoth.onclick=function(){ncSetMode('both',this);};
 if(btnPower)btnPower.onclick=function(){ncSetMode('power',this);};
 if(btnTorque)btnTorque.onclick=function(){ncSetMode('torque',this);};
 window.addEventListener('resize',function(){clearTimeout(NC_RZ);NC_RZ=setTimeout(function(){if(!currentV)return;var m=ncIsMobile();if(m===NC_BP)return;NC_BP=m;renderChart(currentV,activeMode,false);},220);});
 function resetV() {
  currentV=null; ncLicCents=null; /* v4.11 */
  ncEachAtc(function(b){
   b.disabled=true;
   b.classList.remove('is-no-match','is-added','is-loading','is-highlight','is-gated');
   b.querySelector('.nc-atc-label').textContent=L.addcart;
   b.dataset.variantId='';
  });
  var ctaBox=document.getElementById('v-cta');if(ctaBox)ctaBox.classList.add('nc-hide');
  ncStickyApply(); ncAdpSyncUi(); /* v4.10: Leiste (is-gated, #nc-adp-sticky) mit zuruecksetzen */
  document.getElementById('v-info-bar').classList.add('nc-hide');
  /* v4.8: Frage mit der Fahrzeugleiste ausblenden. Die ANTWORT bleibt
     erhalten, sonst muesste man nach jedem Baujahr-Wechsel neu antworten. */
  if (ncAdp.el) ncAdp.el.classList.add('nc-hide');
  if (ncEcu.el) ncEcu.el.classList.add('nc-hide'); /* v4.13: FIN bleibt gespeichert */
  var sn=document.getElementById('nc-soon');if(sn)sn.classList.add('nc-hide');
  var ah=document.getElementById('v-cta-adp-hint');if(ah)ah.classList.add('nc-hide');
  var ehh=document.getElementById('v-cta-ecu-hint');if(ehh)ehh.classList.add('nc-hide');
  var ehs=document.getElementById('nc-ecu-sticky');if(ehs)ehs.classList.add('nc-hide');
  document.getElementById('v-features-box').classList.add('nc-hide');
  /* v4.6: #v-warn-box liegt jetzt oben und nicht mehr IN #v-features-box —
     es wird also nicht mehr automatisch mit ausgeblendet. Ohne diese Zeile
     bliebe der Hinweis des vorigen Fahrzeugs stehen. */
  var w=document.getElementById('v-warn-box');if(w)w.classList.add('nc-hide');
  var h=document.getElementById('v-hint');if(h)h.classList.remove('nc-hide');
  clearChart(); hideCriticalWarning(); hideVideo(); syncGlobalState();
 }
 document.addEventListener('submit',function(e){
  if(!document.getElementById('ngm-v-restore-root')||!e.target.action||!e.target.action.includes('/cart/add'))return;
  if(!currentV){e.preventDefault();e.stopImmediatePropagation();alert(L.pleaseselect);return false;}
  /* v4.8: Ohne Antwort blocken. Mit Antwort und aktiver Frage denselben Weg
     wie die Kaufbuttons nehmen (Adapter/Attribut), statt den lizenz-only-
     Intercept des Drawers (cart-drawer.liquid ab Zeile 1429) laufen zu
     lassen. Auf Lizenzseiten gibt es heute kein natives Formular (main-
     product in product.json disabled), das ist reine Absicherung. */
  if(!ncAdpReady()){e.preventDefault();e.stopImmediatePropagation();ncAdpNudge();return false;}
  if(ncSoon()){e.preventDefault();e.stopImmediatePropagation();ncSoonNudge();return false;} /* v4.13 */
  if(!ncEcuReady()){e.preventDefault();e.stopImmediatePropagation();ncEcuNudge();return false;} /* v4.13 */
  if(ncAdpActive()||ncEcuNeeded()){e.preventDefault();e.stopImmediatePropagation();ncAtcClick.call(atcBtn);return false;}
  syncProps();
 },true);
 function getPrefill() {
  try { var params = new URLSearchParams(window.location.search); var brand = params.get('brand'), model = params.get('model'), engine = params.get('engine'), year = params.get('year'); if (brand) return { brand: brand, model: model || '', engine: engine || '', year: year || '', source: 'url' }; /* v4.11: auch teilweise */ } catch(e) {}
  try { var raw = localStorage.getItem('ngm_vehicle'); if (raw) { var parsed = JSON.parse(raw); if (parsed && parsed.brand && parsed.model && parsed.engine && parsed.year) { var age = Date.now() - (parsed.ts || 0); if (age < 24 * 60 * 60 * 1000) return { brand: parsed.brand, model: parsed.model, engine: parsed.engine, year: parsed.year, source: 'storage' }; } } } catch(e) {}
  return null;
 }
 /* v4.11: NBSP- und Leerzeichen-tolerant. Modellnamen im Metaobjekt tragen teils
    U+00A0, ein Werbelink ?model=Golf%207%20GTI... blieb sonst beim Modell haengen. */
 function ncNormKey(s) { return String(s == null ? '' : s).replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase(); }
 function setSelectValue(el, value) {
  var want = ncNormKey(value); if (!want) return false;
  for (var i = 0; i < el.options.length; i++) {
   if (el.options[i].value === value || ncNormKey(el.options[i].value) === want) { el.value = el.options[i].value; return true; }
  }
  /* SEO-Paket 07.09.2026: Fahrzeugseiten schicken nur den Modell-Anfang
     (?model=Golf 7 R). Dann die erste Option nehmen, die so beginnt. */
  for (var k = 0; k < el.options.length; k++) {
   var ov = el.options[k].value; if (!ov) continue;
   if (ncNormKey(ov).indexOf(want + ' ') === 0) { el.value = ov; return true; }
  }
  return false;
 }
 function autoPrefill() { NC_PREFILLING = true; try { autoPrefillRun(); } finally { NC_PREFILLING = false; } } /* v4.11: kein Reveal-Scroll beim Prefill */
 function autoPrefillRun() {
  var pre = getPrefill(); if (!pre) return;
  if (!setSelectValue(bS, pre.brand)) return; bS.onchange();
  if (!pre.model || !setSelectValue(mS, pre.model)) return; mS.onchange();
  if (!pre.engine || !setSelectValue(eS, pre.engine)) return; eS.onchange();
  if (!pre.year || !setSelectValue(yS, pre.year)) return; yS.onchange();
  try { localStorage.setItem('ngm_vehicle', JSON.stringify({ brand: pre.brand, model: pre.model, engine: pre.engine, year: pre.year, ts: Date.now() })); } catch(e) {}
  setTimeout(function() { var bar = document.getElementById('v-info-bar'); if (bar && !bar.classList.contains('nc-hide')) { var rect = bar.getBoundingClientRect(); var inView = rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight); if (!inView) bar.scrollIntoView({ behavior: 'smooth', block: 'center' }); /* v4.8: ohne Antwort pulst die Frage statt des Kaufbuttons */ if (!ncAdpReady()) { setTimeout(function(){ ncAdpNudge(false); }, 600); } else if (!atcBtn.disabled && !atcBtn.classList.contains('is-no-match')) { setTimeout(function() { atcBtn.classList.add('is-highlight'); }, 600); } } }, 150);
 }
 if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', autoPrefill); } else { setTimeout(autoPrefill, 50); }

 /* v4.8: Zurueck-Taste aus dem Checkout (bfcache, vor allem Safari iOS)
    stellt die Seite MIT altem JS-Zustand wieder her. Ein Spinner, der beim
    Verlassen lief, waere sonst fuer immer eingefroren und der Doppelklick-
    Wachhund (is-loading) wuerde jeden weiteren Kauf blocken. */
 /* v4.11: Chat-Blase (Shopify Inbox) und Cookie-Symbol (Pandectes) ueber
    die Sticky-Leiste heben. Gemessen wird die natuerliche Unterkante des
    Buttons (Rect minus aktueller translate) gegen die Leistenhoehe; der
    Rest wird als CSS-Variable auf <body> geschrieben (CSS in ngm-config.css
    bzw. im Pandectes-Shadow-Root). Nur am Handy (<= 749 px). */
 function ncLiftOverlays() {
  try {
   var bar = document.getElementById('v-sticky'), body = document.body;
   if (!bar || !body) return;
   var on = body.classList.contains('nc-has-sticky') && window.innerWidth <= 749;
   var barH = on ? bar.getBoundingClientRect().height : 0;
   var vh = window.innerHeight || document.documentElement.clientHeight;
   function lift(el, name) {
    if (!el) { body.style.removeProperty(name); return; }
    var tr = getComputedStyle(el).translate || 'none', cur = 0;
    if (tr && tr !== 'none') { var pp = tr.split(' '); cur = pp.length > 1 ? (parseFloat(pp[1]) || 0) : 0; }
    var natBottom = el.getBoundingClientRect().bottom - cur;
    var need = on ? Math.max(barH + 8, barH + 8 - (vh - natBottom)) : 0; /* v4.13: mindestens Leistenhoehe, iOS misst sonst 0 */

    body.style.setProperty(name, Math.round(need) + 'px');
   }
   var chat = document.querySelector('shopify-chat');
   /* v4.13: Chat-Blase. Nicht mehr am Knopf im Shadow-DOM messen (Inbox
      baut ihn um, dann war der Knopf kurz nicht auffindbar und die Anhebung
      fiel weg: "kurz richtig, dann wieder drauf"). Stattdessen nur aus der
      Leistenhoehe rechnen und das fixe Host-Element <shopify-chat> (inset: 0)
      unten einruecken; Knopf und offenes Chatfenster ruecken mit. */
   var cl = on ? Math.round(barH + 8) : 0;
   body.style.setProperty('--nc-chat-lift', cl + 'px');
   if (chat) { if (cl > 0) chat.style.setProperty('bottom', cl + 'px', 'important'); else chat.style.removeProperty('bottom'); }
   var pan = document.querySelector('pandectes-cmp');
   lift(pan && pan.shadowRoot ? pan.shadowRoot.querySelector('.widget.bottom') : null, '--nc-cookie-lift');
  } catch (e) {}
 }
 [1000, 3000, 6000, 12000].forEach(function (ms) { setTimeout(ncLiftOverlays, ms); }); /* Apps laden spaeter als wir */
 (function(){ /* v4.13: Blase bewegt sich nach dem Laden (Nudge) und bei Rotation */
  var n = 0, iv = setInterval(function(){ ncLiftOverlays(); if (++n >= 30) { clearInterval(iv); setInterval(ncLiftOverlays, 5000); } }, 2000); /* danach alle 5 s, Inbox baut den Knopf neu */
  ['resize', 'orientationchange', 'pageshow'].forEach(function(ev){ window.addEventListener(ev, function(){ setTimeout(ncLiftOverlays, 100); }); });
  if (window.visualViewport) window.visualViewport.addEventListener('resize', function(){ setTimeout(ncLiftOverlays, 100); });
 })();

 /* v4.11: Cookie-Symbol von Pandectes ueber die Sticky-Leiste heben. Der
    Button liegt in einem offenen Shadow Root ohne ::part, also haengen wir
    dort eine Regel ein, die --nc-lift (aus ngm-config.css, nur am Handy und
    nur mit sichtbarer Leiste) auswertet. Pandectes laedt spaeter als wir,
    deshalb bis zu 20 s nachfragen. */
 (function ncLiftCookieWidget() {
  var tries = 0;
  function inject() {
   var host = document.querySelector('pandectes-cmp');
   if (!host || !host.shadowRoot) return false;
   if (host.shadowRoot.querySelector('#nc-lift-style')) return true;
   var st = document.createElement('style'); st.id = 'nc-lift-style';
   st.textContent = '.widget.bottom{transition:translate .25s ease;translate:0 calc(-1 * var(--nc-cookie-lift, 0px))}';
   host.shadowRoot.appendChild(st);
   setTimeout(ncLiftOverlays, 50);
   return true;
  }
  try { if (inject()) return; } catch (e) { return; }
  var t = setInterval(function () { tries++; try { if (inject() || tries > 40) clearInterval(t); } catch (e) { clearInterval(t); } }, 500);
 })();

 window.addEventListener('pageshow', function(ev) {
  if (!ev.persisted) return;
  ncEachAtc(function(b){ b.classList.remove('is-loading', 'is-added', 'is-highlight'); b.querySelector('.nc-atc-label').textContent = L.addcart; });
  ncAdpLock(false);
  ncAdpSyncUi();
 });
})();